import React from 'react';

const SkillsLogos = [
  {
    name: 'HTML',
    onHome: true,
    description:
      "HTML est un langage de balise qui sert à définir le contenu et la structure d'un site.",
    svg: (
      <svg width="47" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#E44D26"
            d="M4.27728583 48.601969L0 0h47l-4.2818208 48.5943556L23.4712351 54z"
          />
          <path
            fill="#F16529"
            d="M23.5 49.7086093l15.6168079-4.3567587 3.6742369-41.41807577H23.5z"
          />
          <path
            fill="#EBEBEB"
            d="M23.5 21.9811715h-7.77397l-.5368943-6.0549281H23.5V10.013245H8.76865672l.14062748 1.5863571 1.4439221 16.2944376H23.5zM23.5 37.3588059l-.0259315.0070253-6.5902516-1.810157-.4212893-4.8007073h-5.9401395l.8290263 9.4512309 12.121351 3.4229413L23.5 43.6214509z"
          />
          <path
            fill="#FFF"
            d="M23.5 21.8145695v5.9957124h7.2464679l-.683074 7.7760732L23.5 37.3912744v6.2378647l12.0641418-3.4066368.0885106-1.012973 1.3828653-15.7849242.1435868-1.6100356h-1.5858047zM23.5 10.013245V16.0927152h14.2047891l.1179761-1.3664784.2679392-3.0819732.1406389-1.6310186z"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'CSS',
    onHome: true,
    description:
      "CSS signifie « Cascading Style Sheet » ou « Feuille de Style » en français. Il s'agit d'un ensemble de règles qui définit le style d'un document HTML.",
    svg: (
      <svg width="46" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#264DE4"
            d="M45.86 0l-4.1779639 48.5943556L22.9019328 54 4.1735389 48.601969 0 0z"
          />
          <path fill="#2965F1" d="M37.7801404 45.4313575L41.274 3.46153846H22.93V49.8461538z" />
          <path
            fill="#EBEBEB"
            d="M9.82714286 21.4615385l.50457594 6.2307692H22.93v-6.2307692zM22.93 9.69230769H8.51685714l.52251251 6.23076921H22.93zM22.93 43.6075295v-6.3986926l-.0248727.007178-6.3211606-1.8494803-.4040873-4.9049961H10.4822857l.7951759 9.6565461 11.6264158 3.4973z"
          />
          <path
            fill="#FFF"
            d="M30.0150618 27.8091543l-.6678594 7.7698662L22.93 37.3824991v6.2328855l11.795428-3.4039175.0865392-1.0121644 1.3520636-15.7723244.1403886-1.6087505 1.0387235-12.12592011H22.93v5.99105841h8.1075671l-.523543 6.1348617H22.93v5.9909265z"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'JS',
    onHome: true,
    description:
      "JavaScript est le tronc commun de la formation. Ce langage permet d'écrire des programmes qui vont définir le comportement d'un site Web ou d'une application Mobile.",
    svg: (
      <svg width="57" height="57" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path fill="#F7DF1E" d="M.86 0h54v54h-54z" />
          <path
            d="M37.3820463 42.5322433c1.1003156 1.7978757 2.5318529 3.1193838 5.0637058 3.1193838 2.1269299 0 3.4856331-1.063801 3.4856331-2.5336859 0-1.7614323-1.3959874-2.385309-3.7370842-3.4100635l-1.2832679-.5509899c-3.7041355-1.5792152-6.1648884-3.5575727-6.1648884-7.7398898 0-3.8525909 2.9333076-6.7854191 7.5175221-6.7854191 3.2636624 0 5.6099617 1.1366879 7.3007539 4.1129011l-3.9972061 2.5683939c-.880079-1.5792151-1.8295239-2.2013565-3.3035478-2.2013565-1.5035044 0-2.4564175.9544707-2.4564175 2.2013565 0 1.5410364.9537802 2.1649131 3.1561453 3.1193839l1.2832679.5501222c4.3613768 1.8716303 6.8238638 3.779704 6.8238638 8.069616 0 4.6248444-3.6304342 7.1585303-8.5059852 7.1585303-4.7671668 0-7.8470098-2.2733757-9.3539825-5.2530597l4.1714877-2.4252233zm-18.1330956.4451304c.8063778 1.4317061 1.5399214 2.6421485 3.3035477 2.6421485 1.6864568 0 2.7503553-.6603202 2.7503553-3.2278464v-17.466814h5.1330716v17.53623c0 5.319005-3.11626 7.7398898-7.6649245 7.7398898-4.1099256 0-6.4900407-2.1284697-7.7004745-4.6920912l4.1784244-2.5315167z"
            fill="#000"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'ViteJS',
    onHome: false,
    description:
      "ViteJS est un outil de build nouvelle génération qui améliore considérablement l'expérience de développement frontend. Il offre un serveur de développement ultra-rapide grâce à la compilation native ESM et un build optimisé pour la production basé sur Rollup.",
    svg: (
      <svg
        width="57"
        height="56"
        viewBox="0 0 410 404"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M399.641 59.5246L215.643 388.545C211.844 395.338 202.084 395.378 198.228 388.618L10.5817 59.5563C6.38087 52.1896 12.6802 43.2665 21.0281 44.7586L205.223 77.6824C206.398 77.8924 207.601 77.8904 208.776 77.6763L389.119 44.8058C397.439 43.2894 403.768 52.1434 399.641 59.5246Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M292.965 1.5744L156.801 28.2552C154.563 28.6937 152.906 30.5903 152.771 32.8664L144.395 174.33C144.198 177.662 147.258 180.248 150.51 179.498L188.42 170.749C191.967 169.931 195.172 173.055 194.443 176.622L183.18 231.775C182.422 235.487 185.907 238.661 189.532 237.56L212.947 230.446C216.577 229.344 220.065 232.527 219.297 236.242L201.398 322.875C200.278 328.294 207.486 331.249 210.492 326.603L212.5 323.5L323.454 102.072C325.312 98.3645 322.108 94.137 318.036 94.9228L279.014 102.454C275.347 103.161 272.227 99.746 273.262 96.1583L298.731 7.86689C299.767 4.27314 296.636 0.855181 292.965 1.5744Z"
          fill="url(#paint1_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="6.00017"
            y1="32.9999"
            x2="235"
            y2="344"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#41D1FF" />
            <stop offset="1" stop-color="#BD34FE" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="194.651"
            y1="8.81818"
            x2="236.076"
            y2="292.989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFEA83" />
            <stop offset="0.0833333" stop-color="#FFDD35" />
            <stop offset="1" stop-color="#FFA800" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: 'Vue.js',
    onHome: true,
    description:
      "Vue.js est un framework JavaScript progressif pour la construction d'interfaces utilisateur. Il a été conçu pour rendre le développement d'applications Web plus simple, plus rapide et plus flexible.",
    svg: (
      <svg
        version="1.1"
        width="57"
        height="57"
        viewBox="0 0 261.76 226.69"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(1.3333 0 0 -1.3333 -76.311 313.34)">
          <g transform="translate(178.06 235.01)">
            <path
              d="m0 0-22.669-39.264-22.669 39.264h-75.491l98.16-170.02 98.16 170.02z"
              fill="#41b883"
            />
          </g>
          <g transform="translate(178.06 235.01)">
            <path
              d="m0 0-22.669-39.264-22.669 39.264h-36.227l58.896-102.01 58.896 102.01z"
              fill="#34495e"
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: 'Tailwind',
    onHome: true,
    description:
      'Donnez un coup de boost à votre design grâce au framework CSS axé sur les utilitaires, Tailwind, pour un développement Web plus rapide et efficient.',
    svg: (
      <svg height="57" viewBox=".15 .13 799.7 479.69" width="70" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m400 .13c-106.63 0-173.27 53.3-199.93 159.89 39.99-53.3 86.64-73.28 139.95-59.96 30.42 7.6 52.16 29.67 76.23 54.09 39.2 39.78 84.57 85.82 183.68 85.82 106.62 0 173.27-53.3 199.92-159.9-39.98 53.3-86.63 73.29-139.95 59.97-30.41-7.6-52.15-29.67-76.22-54.09-39.2-39.78-84.58-85.82-183.68-85.82zm-199.93 239.84c-106.62 0-173.27 53.3-199.92 159.9 39.98-53.3 86.63-73.29 139.95-59.96 30.41 7.61 52.15 29.67 76.22 54.08 39.2 39.78 84.58 85.83 183.68 85.83 106.63 0 173.27-53.3 199.93-159.9-39.99 53.3-86.64 73.29-139.95 59.96-30.42-7.59-52.16-29.67-76.23-54.08-39.2-39.78-84.57-85.83-183.68-85.83z"
          fill="#06b6d4"
        />
      </svg>
    ),
  },
  {
    name: 'React',
    onHome: true,
    description:
      'React & React Native sont des librairies JavaScript open-source, développées par Meta, qui permettent de construire des interfaces Web et des applications Mobile fluides et dynamiques.',
    svg: (
      <svg width="62" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="#61DAFB" fillRule="evenodd">
          <path
            d="M62 27.0061799c0-4.0169375-5.1434978-7.8237583-13.0293518-10.1844816C50.7904607 8.96086061 49.9816551 2.70679789 46.4178557.70450904c-.8214431-.4696727-1.7818997-.69214923-2.8308194-.69214923v2.75623712c.581329 0 1.0489197.11123827 1.4406849.321355 1.7187117.96406501 2.4643294 4.63492791 1.8830004 9.35637447-.1390135 1.1618219-.36649 2.3854429-.644517 3.6337835-2.4769669-.5932708-5.1814105-1.0505837-8.0248675-1.3472191-1.7060742-2.2865644-3.4753363-4.3630121-5.257236-6.17990385 4.1198532-3.74502174 7.9869547-5.79674982 10.6155728-5.79674982V0c-3.4753364 0-8.0248675 2.42252232-12.6249491 6.62485695C26.3746433 2.44724193 21.8251121.04943923 18.3497758.04943923v2.75623713c2.6159804 0 6.4957195 2.03936827 10.6155728 5.7596704-1.7692622 1.81689174-3.5385243 3.88097964-5.2193233 6.16754404-2.8560946.2966354-5.5605381.7539483-8.0375051 1.3595789-.2906645-1.2359808-.5055035-2.4348822-.6571545-3.5843443-.5939666-4.72144653.1390134-8.39230942 1.8450876-9.36873423.3791276-.22247654.8719935-.32135501 1.4533225-.32135501V.06179904c-1.0615573 0-2.0220139.22247654-2.8560946.69214923-3.5511618 2.00228886-4.3473298 8.24399176-2.5148797 16.08010983C5.11822258 19.2071412 0 23.0016022 0 27.0061799c0 4.0169375 5.14349776 7.8237583 13.0293518 10.1844816-1.8198125 7.8608377-1.0110069 14.1149004 2.5527925 16.1171893C16.4035874 53.7775235 17.364044 54 18.4256013 54c3.4753363 0 8.0248675-2.4225223 12.624949-6.6248569 4.6000816 4.177615 9.1496128 6.5754177 12.6249491 6.5754177 1.0615573 0 2.0220138-.2224766 2.8560946-.6921493 3.5511618-2.0022888 4.3473298-8.2439917 2.5148797-16.0801098C56.8817774 34.8175784 62 31.0107576 62 27.0061799zm-16.4541378-8.2439918c-.4675907 1.5944152-1.0489197 3.2382697-1.7060742 4.8821241-.518141-.9887846-1.0615573-1.9775692-1.6555238-2.9663539-.581329-.9887846-1.2005708-1.9528496-1.8198125-2.892195 1.7945373.259556 3.5258867.580911 5.1814105.9764248zm-5.7880147 13.1631953c-.9857317 1.668574-1.9967387 3.2506294-3.0456583 4.7214465-1.8830005.1606775-3.791276.2471962-5.7121892.2471962-1.9082756 0-3.8165512-.0865187-5.686914-.2348364-1.0489197-1.4708171-2.0725642-3.0405127-3.0582959-4.6967269-.9604566-1.6191348-1.8324501-3.2629892-2.6286181-4.9192035.7835304-1.6562142 1.6681615-3.3124284 2.6159805-4.9315633.9857317-1.668574 1.9967387-3.2506294 3.0456583-4.7214465 1.8830005-.1606775 3.791276-.2471962 5.7121892-.2471962 1.9082756 0 3.8165512.0865187 5.686914.2348364 1.0489197 1.4708171 2.0725642 3.0405127 3.0582959 4.6967269.9604566 1.6191348 1.8324501 3.2629893 2.6286181 4.9192035-.796168 1.6562142-1.6681615 3.3124285-2.6159805 4.9315633zm4.0819405-1.606775c.6824297 1.6562142 1.2637587 3.3124285 1.743987 4.9192035-1.6555239.3955138-3.3995108.7292286-5.2066857.9887846.6192417-.9517052 1.2384835-1.92813 1.8198125-2.9292745.5813289-.9887846 1.1247452-1.989929 1.6428862-2.9787136zM31.0252752 43.5065232c-1.1752956-1.1865415-2.3505911-2.5090409-3.5132491-3.9551384 1.1373828.0494392 2.3000408.0865186 3.4753363.0865186 1.1879332 0 2.3632287-.0247196 3.5132491-.0865186-1.1373828 1.4460975-2.3126784 2.7685969-3.4753363 3.9551384zm-9.4023645-7.2799267c-1.7945373-.259556-3.5258866-.580911-5.1814105-.9764248.4675907-1.5944152 1.0489197-3.2382697 1.7060742-4.8821241.5181411.9887846 1.0615573 1.9775692 1.6555238 2.9663539.5939666.9887846 1.2005708 1.9528496 1.8198125 2.892195zm9.3391765-25.7207599c1.1752956 1.1865415 2.3505912 2.5090409 3.5132491 3.9551385-1.1373828-.0494393-2.3000407-.0865187-3.4753363-.0865187-1.1879331 0-2.3632287.0247196-3.5132491.0865187 1.1373828-1.4460976 2.3126784-2.768597 3.4753363-3.9551385zm-9.3518141 7.2799267c-.6192417.9517052-1.2384835 1.92813-1.8198124 2.9292745-.581329.9887846-1.1247452 1.9775692-1.6428863 2.9663538-.6824297-1.6562142-1.2637587-3.3124285-1.743987-4.9192035 1.6555239-.383154 3.3995108-.7168688 5.2066857-.9764248zM10.1732572 33.2602426c-4.47370563-1.8663309-7.36771297-4.3135729-7.36771297-6.2540627 0-1.9404898 2.89400734-4.4000916 7.36771297-6.2540627 1.0868325-.4573129 2.2747656-.8651866 3.5006115-1.2483406.7203425 2.4225223 1.6681615 4.9439231 2.843457 7.5271229-1.1626579 2.57084-2.0978394 5.079881-2.8055442 7.4900435-1.2511211-.383154-2.4390542-.8033875-3.5385243-1.2607004zm6.7990216 17.6621653c-1.7187117-.964065-2.4643294-4.6349279-1.8830004-9.3563745.1390135-1.1618219.36649-2.3854429.644517-3.6337835 2.4769669.5932708 5.1814105 1.0505837 8.0248675 1.3472191 1.7060742 2.2865644 3.4753363 4.3630121 5.257236 6.1799039-4.1198532 3.7450217-7.9869547 5.7967498-10.6155728 5.7967498-.5686914-.0123598-1.0489197-.1235981-1.4280473-.3337148zm29.9763555-9.4181735c.5939666 4.7214465-.1390134 8.3923094-1.8450876 9.3687342-.3791276.2224766-.8719935.321355-1.4533225.321355-2.6159804 0-6.4957195-2.0393682-10.6155728-5.7596704 1.7692622-1.8168917 3.5385243-3.8809796 5.2193233-6.167544 2.8560946-.2966354 5.5605381-.7539483 8.0375051-1.3595789.2906645 1.2483406.5181411 2.447242.6571545 3.5967041zm4.8654709-8.2439918c-1.0868325.4573129-2.2747656.8651866-3.5006115 1.2483406-.7203425-2.4225223-1.6681615-4.9439231-2.843457-7.5271229 1.162658-2.57084 2.0978394-5.079881 2.8055442-7.4900435 1.2511211.383154 2.4390542.8033875 3.5511619 1.2607004 4.4737056 1.866331 7.367713 4.3135729 7.367713 6.2540627-.0126376 1.9404898-2.906645 4.4000916-7.3803506 6.2540627z"
            fillRule="nonzero"
          />
          <ellipse cx="30.76" cy="27.235" rx="5.767" ry="5.635" />
        </g>
      </svg>
    ),
  },
  {
    name: 'Redux',
    onHome: true,
    description:
      "Gérez facilement l'état de votre application avec Redux, le gestionnaire d'état global le plus populaire, pour les applications React.",
    svg: (
      <svg
        width="57"
        height="57"
        viewBox="0 0 256 244"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
      >
        <path
          d="M177.381 169.733c9.447-.978 16.614-9.122 16.288-18.896-.325-9.773-8.47-17.592-18.243-17.592h-.651c-10.1.326-17.918 8.796-17.592 18.895.326 4.887 2.28 9.122 5.212 12.054-11.076 21.828-28.016 37.791-53.426 51.148-17.266 9.122-35.183 12.38-53.1 10.1-14.66-1.955-26.062-8.47-33.23-19.222-10.424-15.963-11.401-33.23-2.605-50.496 6.19-12.38 15.962-21.502 22.152-26.063-1.303-4.235-3.258-11.402-4.235-16.614-47.237 34.207-42.35 80.468-28.016 102.295 10.75 16.29 32.577 26.389 56.684 26.389 6.515 0 13.03-.652 19.546-2.28 41.699-8.145 73.299-32.905 91.216-69.718zm57.336-40.397c-24.759-28.995-61.245-44.958-102.944-44.958h-5.212c-2.932-5.864-9.122-9.774-15.963-9.774h-.652C99.848 74.93 92.03 83.4 92.355 93.5c.326 9.773 8.47 17.592 18.243 17.592h.651c7.167-.326 13.357-4.887 15.963-11.077h5.864c24.759 0 48.214 7.167 69.39 21.176 16.288 10.751 28.016 24.76 34.531 41.7 5.538 13.683 5.212 27.04-.652 38.443-9.121 17.266-24.432 26.714-44.63 26.714-13.031 0-25.41-3.91-31.926-6.842-3.583 3.258-10.099 8.47-14.66 11.729 14.009 6.515 28.343 10.099 42.025 10.099 31.274 0 54.404-17.267 63.2-34.533 9.447-18.896 8.795-51.474-15.637-79.165zM69.225 175.27c.326 9.774 8.47 17.592 18.243 17.592h.652c10.099-.325 17.917-8.796 17.591-18.895-.325-9.774-8.47-17.592-18.243-17.592h-.651c-.652 0-1.63 0-2.28.325-13.357-22.153-18.895-46.26-16.94-72.323 1.302-19.547 7.818-36.488 19.22-50.497 9.447-12.054 27.69-17.918 40.07-18.243 34.531-.652 49.19 42.351 50.168 59.618 4.235.977 11.402 3.258 16.289 4.887C189.434 27.366 156.857 0 125.584 0c-29.32 0-56.359 21.176-67.11 52.451-14.985 41.7-5.212 81.771 13.031 113.372-1.628 2.28-2.606 5.864-2.28 9.448z"
          fill="#764ABC"
        />
      </svg>
    ),
  },
  {
    name: 'TypeScript',
    onHome: true,
    description:
      'Améliorez votre code JavaScript avec la vérification statique des types, des outils améliorés et des fonctionnalités, en utilisant TypeScript.',
    svg: (
      <svg
        fill="none"
        height="57"
        viewBox="0 0 512 512"
        width="57"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#3178c6" height="512" rx="50" width="512" />
        <rect fill="#3178c6" height="512" rx="50" width="512" />
        <path
          clipRule="evenodd"
          d="m316.939 407.424v50.061c8.138 4.172 17.763 7.3 28.875 9.386s22.823 3.129 35.135 3.129c11.999 0 23.397-1.147 34.196-3.442 10.799-2.294 20.268-6.075 28.406-11.342 8.138-5.266 14.581-12.15 19.328-20.65s7.121-19.007 7.121-31.522c0-9.074-1.356-17.026-4.069-23.857s-6.625-12.906-11.738-18.225c-5.112-5.319-11.242-10.091-18.389-14.315s-15.207-8.213-24.18-11.967c-6.573-2.712-12.468-5.345-17.685-7.9-5.217-2.556-9.651-5.163-13.303-7.822-3.652-2.66-6.469-5.476-8.451-8.448-1.982-2.973-2.974-6.336-2.974-10.091 0-3.441.887-6.544 2.661-9.308s4.278-5.136 7.512-7.118c3.235-1.981 7.199-3.52 11.894-4.615 4.696-1.095 9.912-1.642 15.651-1.642 4.173 0 8.581.313 13.224.938 4.643.626 9.312 1.591 14.008 2.894 4.695 1.304 9.259 2.947 13.694 4.928 4.434 1.982 8.529 4.276 12.285 6.884v-46.776c-7.616-2.92-15.937-5.084-24.962-6.492s-19.381-2.112-31.066-2.112c-11.895 0-23.163 1.278-33.805 3.833s-20.006 6.544-28.093 11.967c-8.086 5.424-14.476 12.333-19.171 20.729-4.695 8.395-7.043 18.433-7.043 30.114 0 14.914 4.304 27.638 12.912 38.172 8.607 10.533 21.675 19.45 39.204 26.751 6.886 2.816 13.303 5.579 19.25 8.291s11.086 5.528 15.415 8.448c4.33 2.92 7.747 6.101 10.252 9.543 2.504 3.441 3.756 7.352 3.756 11.733 0 3.233-.783 6.231-2.348 8.995s-3.939 5.162-7.121 7.196-7.147 3.624-11.894 4.771c-4.748 1.148-10.303 1.721-16.668 1.721-10.851 0-21.597-1.903-32.24-5.71-10.642-3.806-20.502-9.516-29.579-17.13zm-84.159-123.342h64.22v-41.082h-179v41.082h63.906v182.918h50.874z"
          fill="#fff"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: 'React Native',
    onHome: true,
    description:
      'React & React Native sont des librairies JavaScript open-source, développées par Meta, qui permettent de construire des interfaces Web et des applications Mobile fluides et dynamiques.',
    svg: (
      <svg width="62" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="#00a7d4" fillRule="evenodd">
          <path
            d="M62 27.0061799c0-4.0169375-5.1434978-7.8237583-13.0293518-10.1844816C50.7904607 8.96086061 49.9816551 2.70679789 46.4178557.70450904c-.8214431-.4696727-1.7818997-.69214923-2.8308194-.69214923v2.75623712c.581329 0 1.0489197.11123827 1.4406849.321355 1.7187117.96406501 2.4643294 4.63492791 1.8830004 9.35637447-.1390135 1.1618219-.36649 2.3854429-.644517 3.6337835-2.4769669-.5932708-5.1814105-1.0505837-8.0248675-1.3472191-1.7060742-2.2865644-3.4753363-4.3630121-5.257236-6.17990385 4.1198532-3.74502174 7.9869547-5.79674982 10.6155728-5.79674982V0c-3.4753364 0-8.0248675 2.42252232-12.6249491 6.62485695C26.3746433 2.44724193 21.8251121.04943923 18.3497758.04943923v2.75623713c2.6159804 0 6.4957195 2.03936827 10.6155728 5.7596704-1.7692622 1.81689174-3.5385243 3.88097964-5.2193233 6.16754404-2.8560946.2966354-5.5605381.7539483-8.0375051 1.3595789-.2906645-1.2359808-.5055035-2.4348822-.6571545-3.5843443-.5939666-4.72144653.1390134-8.39230942 1.8450876-9.36873423.3791276-.22247654.8719935-.32135501 1.4533225-.32135501V.06179904c-1.0615573 0-2.0220139.22247654-2.8560946.69214923-3.5511618 2.00228886-4.3473298 8.24399176-2.5148797 16.08010983C5.11822258 19.2071412 0 23.0016022 0 27.0061799c0 4.0169375 5.14349776 7.8237583 13.0293518 10.1844816-1.8198125 7.8608377-1.0110069 14.1149004 2.5527925 16.1171893C16.4035874 53.7775235 17.364044 54 18.4256013 54c3.4753363 0 8.0248675-2.4225223 12.624949-6.6248569 4.6000816 4.177615 9.1496128 6.5754177 12.6249491 6.5754177 1.0615573 0 2.0220138-.2224766 2.8560946-.6921493 3.5511618-2.0022888 4.3473298-8.2439917 2.5148797-16.0801098C56.8817774 34.8175784 62 31.0107576 62 27.0061799zm-16.4541378-8.2439918c-.4675907 1.5944152-1.0489197 3.2382697-1.7060742 4.8821241-.518141-.9887846-1.0615573-1.9775692-1.6555238-2.9663539-.581329-.9887846-1.2005708-1.9528496-1.8198125-2.892195 1.7945373.259556 3.5258867.580911 5.1814105.9764248zm-5.7880147 13.1631953c-.9857317 1.668574-1.9967387 3.2506294-3.0456583 4.7214465-1.8830005.1606775-3.791276.2471962-5.7121892.2471962-1.9082756 0-3.8165512-.0865187-5.686914-.2348364-1.0489197-1.4708171-2.0725642-3.0405127-3.0582959-4.6967269-.9604566-1.6191348-1.8324501-3.2629892-2.6286181-4.9192035.7835304-1.6562142 1.6681615-3.3124284 2.6159805-4.9315633.9857317-1.668574 1.9967387-3.2506294 3.0456583-4.7214465 1.8830005-.1606775 3.791276-.2471962 5.7121892-.2471962 1.9082756 0 3.8165512.0865187 5.686914.2348364 1.0489197 1.4708171 2.0725642 3.0405127 3.0582959 4.6967269.9604566 1.6191348 1.8324501 3.2629893 2.6286181 4.9192035-.796168 1.6562142-1.6681615 3.3124285-2.6159805 4.9315633zm4.0819405-1.606775c.6824297 1.6562142 1.2637587 3.3124285 1.743987 4.9192035-1.6555239.3955138-3.3995108.7292286-5.2066857.9887846.6192417-.9517052 1.2384835-1.92813 1.8198125-2.9292745.5813289-.9887846 1.1247452-1.989929 1.6428862-2.9787136zM31.0252752 43.5065232c-1.1752956-1.1865415-2.3505911-2.5090409-3.5132491-3.9551384 1.1373828.0494392 2.3000408.0865186 3.4753363.0865186 1.1879332 0 2.3632287-.0247196 3.5132491-.0865186-1.1373828 1.4460975-2.3126784 2.7685969-3.4753363 3.9551384zm-9.4023645-7.2799267c-1.7945373-.259556-3.5258866-.580911-5.1814105-.9764248.4675907-1.5944152 1.0489197-3.2382697 1.7060742-4.8821241.5181411.9887846 1.0615573 1.9775692 1.6555238 2.9663539.5939666.9887846 1.2005708 1.9528496 1.8198125 2.892195zm9.3391765-25.7207599c1.1752956 1.1865415 2.3505912 2.5090409 3.5132491 3.9551385-1.1373828-.0494393-2.3000407-.0865187-3.4753363-.0865187-1.1879331 0-2.3632287.0247196-3.5132491.0865187 1.1373828-1.4460976 2.3126784-2.768597 3.4753363-3.9551385zm-9.3518141 7.2799267c-.6192417.9517052-1.2384835 1.92813-1.8198124 2.9292745-.581329.9887846-1.1247452 1.9775692-1.6428863 2.9663538-.6824297-1.6562142-1.2637587-3.3124285-1.743987-4.9192035 1.6555239-.383154 3.3995108-.7168688 5.2066857-.9764248zM10.1732572 33.2602426c-4.47370563-1.8663309-7.36771297-4.3135729-7.36771297-6.2540627 0-1.9404898 2.89400734-4.4000916 7.36771297-6.2540627 1.0868325-.4573129 2.2747656-.8651866 3.5006115-1.2483406.7203425 2.4225223 1.6681615 4.9439231 2.843457 7.5271229-1.1626579 2.57084-2.0978394 5.079881-2.8055442 7.4900435-1.2511211-.383154-2.4390542-.8033875-3.5385243-1.2607004zm6.7990216 17.6621653c-1.7187117-.964065-2.4643294-4.6349279-1.8830004-9.3563745.1390135-1.1618219.36649-2.3854429.644517-3.6337835 2.4769669.5932708 5.1814105 1.0505837 8.0248675 1.3472191 1.7060742 2.2865644 3.4753363 4.3630121 5.257236 6.1799039-4.1198532 3.7450217-7.9869547 5.7967498-10.6155728 5.7967498-.5686914-.0123598-1.0489197-.1235981-1.4280473-.3337148zm29.9763555-9.4181735c.5939666 4.7214465-.1390134 8.3923094-1.8450876 9.3687342-.3791276.2224766-.8719935.321355-1.4533225.321355-2.6159804 0-6.4957195-2.0393682-10.6155728-5.7596704 1.7692622-1.8168917 3.5385243-3.8809796 5.2193233-6.167544 2.8560946-.2966354 5.5605381-.7539483 8.0375051-1.3595789.2906645 1.2483406.5181411 2.447242.6571545 3.5967041zm4.8654709-8.2439918c-1.0868325.4573129-2.2747656.8651866-3.5006115 1.2483406-.7203425-2.4225223-1.6681615-4.9439231-2.843457-7.5271229 1.162658-2.57084 2.0978394-5.079881 2.8055442-7.4900435 1.2511211.383154 2.4390542.8033875 3.5511619 1.2607004 4.4737056 1.866331 7.367713 4.3135729 7.367713 6.2540627-.0126376 1.9404898-2.906645 4.4000916-7.3803506 6.2540627z"
            fillRule="nonzero"
          />
          <ellipse cx="30.76" cy="27.235" rx="5.767" ry="5.635" />
        </g>
      </svg>
    ),
  },
  {
    name: 'Expo',
    onHome: true,
    description:
      "Créez des applications Mobile natives avec la puissance de React Native, en utilisant Expo, la plateforme open-source qui contient une foule d'outils et d'API intégrés qui permet de développer et publier facilement votre prochaine application, sans jamais vous soucier des configurations complexes.",
    svg: (
      <svg
        width="57"
        height="57"
        viewBox="0 0 256 227"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
      >
        <g>
          <path
            d="M159.032004,16.2735642 C149.604559,1.90793512 147.35993,0 128.168347,0 L128.168347,0 L127.943884,0 L127.719421,0 L127.719421,0 C108.527839,0 106.395441,1.90793512 96.855765,16.2735642 C87.9894783,29.7413415 0,190.905743 0,195.395002 C0,201.904428 1.68347216,208.077159 7.74397194,216.831214 C13.9167032,225.697501 24.5786936,230.635686 32.3226655,222.779483 C37.5975449,217.504603 94.0499781,120.199912 121.322227,83.3879877 L121.322227,83.3879877 C124.57694,78.7864972 131.310829,78.7864972 134.677773,83.3879877 L134.677773,83.3879877 C161.950022,120.199912 218.402455,217.504603 223.677335,222.779483 C231.421306,230.635686 242.083297,225.697501 248.256028,216.831214 C254.316528,208.077159 256,201.904428 256,195.395002 C255.887769,190.905743 167.89829,29.62911 159.032004,16.2735642 Z"
            fill="#000000"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    name: 'Next.js',
    onHome: true,
    description:
      "Next.js est un framework surpuissant, adapté au référencement et extrêmement convivial, pour le développement de sites Web statiques et d'applications Web.",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57px"
        height="57px"
        viewBox="0 0 256 256"
        fill="none"
      >
        <title></title>
        <defs>
          <circle id="path-1" cx="128" cy="128" r="128"></circle>
          <linearGradient
            x1="55.6325605%"
            y1="56.3850422%"
            x2="83.2279093%"
            y2="96.0801119%"
            id="nextjsLinearGradient-3"
          >
            <stop stopColor="#FFFFFF" offset="0%"></stop>
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
          </linearGradient>
          <linearGradient
            x1="50%"
            y1="0%"
            x2="49.9534722%"
            y2="73.4375%"
            id="nextjsLinearGradient-4"
          >
            <stop stopColor="#FFFFFF" offset="0%"></stop>
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
          </linearGradient>
        </defs>
        <g>
          {/* <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask> */}
          <g mask="url(#mask-2)">
            <circle fill="#000000" cx="128" cy="128" r="128"></circle>
            <path
              d="M212.6336,224.028444 L98.3352889,76.8 L76.8,76.8 L76.8,179.157333 L94.0282311,179.157333 L94.0282311,98.6788978 L199.109689,234.446222 C203.851378,231.273244 208.368356,227.790222 212.6336,224.028444 Z"
              fill="url(#nextjsLinearGradient-3)"
            ></path>
            <rect
              fill="url(#nextjsLinearGradient-4)"
              x="163.555556"
              y="76.8"
              width="17.0666667"
              height="102.4"
            ></rect>
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: 'Node.js',
    onHome: true,
    description:
      "Node.js est l'environnement d'exécution des programmes JavaScript, côté serveur. C'est lui qui va interprêter vos programmes.",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="111"
        height="54"
        viewBox="0 0 111 33"
        fill="none"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M97.6896 32.7407C97.4026 32.7407 97.1348 32.6637 96.8861 32.5289L94.3415 31.0081C93.9588 30.7963 94.1501 30.7193 94.2649 30.6808C94.7815 30.5075 94.8772 30.469 95.4129 30.161C95.4703 30.1225 95.5468 30.1418 95.6042 30.1803L97.5557 31.3546C97.6322 31.3931 97.7279 31.3931 97.7853 31.3546L105.419 26.9075C105.496 26.869 105.534 26.792 105.534 26.6958V17.8209C105.534 17.7247 105.496 17.6477 105.419 17.6092L97.7853 13.1814C97.7088 13.1429 97.6131 13.1429 97.5557 13.1814L89.9219 17.6092C89.8454 17.6477 89.8071 17.7439 89.8071 17.8209V26.6958C89.8071 26.7728 89.8454 26.869 89.9219 26.9075L92.0073 28.1204C93.1361 28.6979 93.844 28.0241 93.844 27.3503V18.591C93.844 18.4755 93.9397 18.36 94.0736 18.36H95.0494C95.1642 18.36 95.279 18.4562 95.279 18.591V27.3503C95.279 28.8712 94.4563 29.7567 93.0213 29.7567C92.5813 29.7567 92.2369 29.7567 91.2612 29.2755L89.2523 28.1204C88.7548 27.8316 88.4487 27.2926 88.4487 26.715V17.8402C88.4487 17.2626 88.7548 16.7236 89.2523 16.4348L96.8861 11.9878C97.3644 11.7183 98.0149 11.7183 98.4932 11.9878L106.127 16.4348C106.624 16.7236 106.931 17.2626 106.931 17.8402V26.715C106.931 27.2926 106.624 27.8316 106.127 28.1204L98.4932 32.5674C98.2636 32.6637 97.9766 32.7407 97.6896 32.7407Z"
            fill="#5FA04E"
          />
          <path
            d="M100.062 26.6379C96.7137 26.6379 96.0249 25.0978 96.0249 23.7887C96.0249 23.6732 96.1206 23.5577 96.2545 23.5577H97.2494C97.3642 23.5577 97.4598 23.6347 97.4598 23.7502C97.6129 24.7705 98.0529 25.2711 100.081 25.2711C101.688 25.2711 102.377 24.9053 102.377 24.039C102.377 23.5385 102.185 23.1727 99.6792 22.9224C97.5937 22.7106 96.2928 22.2486 96.2928 20.5737C96.2928 19.0144 97.5937 18.0903 99.7748 18.0903C102.224 18.0903 103.429 18.9374 103.582 20.7855C103.582 20.8433 103.563 20.901 103.525 20.9588C103.486 20.9973 103.429 21.0358 103.372 21.0358H102.358C102.262 21.0358 102.166 20.9588 102.147 20.8625C101.918 19.8037 101.325 19.4572 99.7557 19.4572C97.9955 19.4572 97.7851 20.0732 97.7851 20.5352C97.7851 21.0935 98.0338 21.2668 100.406 21.5748C102.759 21.8828 103.869 22.3256 103.869 23.9812C103.869 25.6753 102.472 26.6379 100.062 26.6379Z"
            fill="#5FA04E"
          />
          <path
            d="M111.083 17.3202C111.083 18.1288 110.413 18.8026 109.609 18.8026C108.806 18.8026 108.136 18.148 108.136 17.3202C108.136 16.4732 108.825 15.8379 109.609 15.8379C110.394 15.8379 111.083 16.4924 111.083 17.3202ZM108.366 17.3202C108.366 18.0133 108.921 18.5716 109.59 18.5716C110.279 18.5716 110.834 17.994 110.834 17.3202C110.834 16.6272 110.279 16.0882 109.59 16.0882C108.94 16.0882 108.366 16.6272 108.366 17.3202ZM109.055 16.4924H109.629C109.82 16.4924 110.203 16.4924 110.203 16.9352C110.203 17.2432 110.011 17.301 109.896 17.3395C110.126 17.3587 110.145 17.5128 110.164 17.7245C110.183 17.8593 110.203 18.0903 110.241 18.1673H109.896C109.896 18.0903 109.839 17.6668 109.839 17.6475C109.82 17.5513 109.782 17.5128 109.667 17.5128H109.38V18.1865H109.055V16.4924ZM109.361 17.224H109.609C109.82 17.224 109.858 17.07 109.858 16.993C109.858 16.762 109.705 16.762 109.609 16.762H109.342V17.224H109.361Z"
            fill="#5FA04E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1565 17.4415C18.1565 17.095 17.9652 16.7678 17.6591 16.5945L9.56614 11.8779C9.43221 11.8009 9.27915 11.7624 9.12609 11.7432C9.10696 11.7432 9.04956 11.7432 9.04956 11.7432C8.89651 11.7432 8.74345 11.8009 8.60952 11.8779L0.497439 16.5752C0.191323 16.7485 0 17.0758 0 17.4415L0.0191323 30.0704C0.0191323 30.2437 0.114794 30.4169 0.267852 30.4939C0.42091 30.5902 0.612233 30.5902 0.746159 30.4939L5.56749 27.7217C5.87361 27.5485 6.06493 27.2212 6.06493 26.8747V20.9645C6.06493 20.618 6.25625 20.2907 6.56237 20.1175L8.60952 18.9239C8.76258 18.8276 8.93477 18.7891 9.10696 18.7891C9.27915 18.7891 9.45134 18.8276 9.58527 18.9239L11.6324 20.1175C11.9385 20.2907 12.1299 20.618 12.1299 20.9645V26.8747C12.1299 27.2212 12.3212 27.5485 12.6273 27.7217L17.4104 30.4939C17.5634 30.5902 17.7547 30.5902 17.9078 30.4939C18.0609 30.4169 18.1565 30.2437 18.1565 30.0704V17.4415Z"
            fill="#333333"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.1479 0.0577539C56.9949 -0.0192513 56.8035 -0.0192513 56.6696 0.0577539C56.5165 0.15401 56.4209 0.308021 56.4209 0.481283V12.9946C56.4209 13.1101 56.3635 13.2256 56.2487 13.3027C56.1339 13.3604 56.0191 13.3604 55.9043 13.3027L53.8763 12.1283C53.5702 11.9551 53.2067 11.9551 52.9005 12.1283L44.7885 16.8449C44.4823 17.0182 44.291 17.3454 44.291 17.6919V27.1058C44.291 27.4524 44.4823 27.7796 44.7885 27.9529L52.9005 32.6695C53.2067 32.8427 53.5702 32.8427 53.8763 32.6695L61.9884 27.9529C62.2945 27.7796 62.4858 27.4524 62.4858 27.1058V3.6385C62.4858 3.27272 62.2945 2.94545 61.9884 2.77219L57.1479 0.0577539ZM56.4017 24.0064C56.4017 24.1026 56.3635 24.1796 56.287 24.2181L53.5128 25.8353C53.4362 25.8738 53.3406 25.8738 53.2641 25.8353L50.4899 24.2181C50.4133 24.1796 50.3751 24.0834 50.3751 24.0064V20.7722C50.3751 20.6759 50.4133 20.5989 50.4899 20.5604L53.2641 18.9433C53.3406 18.9048 53.4362 18.9048 53.5128 18.9433L56.287 20.5604C56.3635 20.5989 56.4017 20.6952 56.4017 20.7722V24.0064Z"
            fill="#333333"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M84.1429 20.6951C84.449 20.5218 84.6212 20.1946 84.6212 19.848V17.5571C84.6212 17.2106 84.4299 16.8833 84.1429 16.7101L76.0882 12.0128C75.7821 11.8395 75.4186 11.8395 75.1125 12.0128L67.0004 16.7293C66.6943 16.9026 66.5029 17.2299 66.5029 17.5764V26.9903C66.5029 27.3368 66.6943 27.6641 67.0004 27.8373L75.0551 32.4576C75.3612 32.6309 75.7247 32.6309 76.0117 32.4576L80.8904 29.724C81.0435 29.647 81.1391 29.4737 81.1391 29.3004C81.1391 29.1272 81.0435 28.9539 80.8904 28.8769L72.7401 24.1603C72.587 24.0641 72.4913 23.9101 72.4913 23.7368V20.7914C72.4913 20.6181 72.587 20.4448 72.7401 20.3678L75.2846 18.9047C75.4377 18.8085 75.629 18.8085 75.7821 18.9047L78.3267 20.3678C78.4797 20.4641 78.5754 20.6181 78.5754 20.7914V23.1015C78.5754 23.2748 78.6711 23.448 78.8241 23.525C78.9772 23.6213 79.1685 23.6213 79.3216 23.525L84.1429 20.6951Z"
            fill="#333333"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.4759 20.2525C75.5333 20.214 75.6099 20.214 75.6673 20.2525L77.217 21.1573C77.2744 21.1958 77.3126 21.2536 77.3126 21.3306V23.1402C77.3126 23.2172 77.2744 23.275 77.217 23.3135L75.6673 24.2183C75.6099 24.2568 75.5333 24.2568 75.4759 24.2183L73.9262 23.3135C73.8688 23.275 73.8306 23.2172 73.8306 23.1402V21.3306C73.8306 21.2536 73.8688 21.1958 73.9262 21.1573L75.4759 20.2525Z"
            fill="#5FA04E"
          />
          <path
            d="M31.7207 12.0513C31.4145 11.8781 31.051 11.8781 30.7449 12.0513L22.6902 16.7294C22.3841 16.9027 22.2119 17.2299 22.2119 17.5765V26.9518C22.2119 27.2984 22.4032 27.6256 22.6902 27.7989L30.7449 32.477C31.051 32.6502 31.4145 32.6502 31.7207 32.477L39.7753 27.7989C40.0815 27.6256 40.2536 27.2984 40.2536 26.9518V17.5765C40.2536 17.2299 40.0623 16.9027 39.7753 16.7294L31.7207 12.0513Z"
            fill="url(#paint0_linear)"
          />
          <path
            d="M39.7946 16.7294L31.7017 12.0513C31.6252 12.0128 31.5295 11.9743 31.453 11.9551L22.3843 27.5679C22.4608 27.6641 22.5565 27.7411 22.6521 27.7989L30.7451 32.477C30.9747 32.6117 31.2425 32.6502 31.4912 32.5732L40.0051 16.9027C39.9477 16.8257 39.8712 16.7679 39.7946 16.7294Z"
            fill="url(#paint1_linear)"
          />
          <path
            d="M30.4776 10.3379L30.3628 10.3956H30.5158L30.4776 10.3379Z"
            fill="url(#paint2_linear)"
          />
          <path
            d="M39.7947 27.7991C40.0243 27.6643 40.1965 27.4333 40.273 27.183L31.4147 11.936C31.1852 11.8975 30.9364 11.9167 30.726 12.0515L22.6904 16.7103L31.3573 32.6119C31.4721 32.5926 31.6061 32.5541 31.7209 32.4964L39.7947 27.7991Z"
            fill="url(#paint3_linear)"
          />
          <path
            d="M40.5598 27.6446L40.5024 27.5483V27.6831L40.5598 27.6446Z"
            fill="url(#paint4_linear)"
          />
          <path
            d="M39.7952 27.7989L31.7214 32.4769C31.6066 32.5347 31.4918 32.5732 31.3579 32.5924L31.511 32.8812L40.4649 27.6641V27.5486L40.2353 27.1636C40.2162 27.4331 40.044 27.6641 39.7952 27.7989Z"
            fill="url(#paint5_linear)"
          />
          <path
            d="M39.7952 27.7989L31.7214 32.4769C31.6066 32.5347 31.4918 32.5732 31.3579 32.5924L31.511 32.8812L40.4649 27.6641V27.5486L40.2353 27.1636C40.2162 27.4331 40.044 27.6641 39.7952 27.7989Z"
            fill="url(#paint6_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="34.5132"
            y1="15.5354"
            x2="27.1574"
            y2="30.4484"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3F873F" />
            <stop offset="0.3296" stopColor="#3F8B3D" />
            <stop offset="0.6367" stopColor="#3E9638" />
            <stop offset="0.9341" stopColor="#3DA92E" />
            <stop offset="1" stopColor="#3DAE2B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="30.0088"
            y1="23.3589"
            x2="50.5328"
            y2="8.28841"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1376" stopColor="#3F873F" />
            <stop offset="0.4016" stopColor="#52A044" />
            <stop offset="0.7129" stopColor="#64B749" />
            <stop offset="0.9081" stopColor="#6ABF4B" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="21.9174"
            y1="10.3605"
            x2="40.5549"
            y2="10.3605"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0919165" stopColor="#6ABF4B" />
            <stop offset="0.2871" stopColor="#64B749" />
            <stop offset="0.5984" stopColor="#52A044" />
            <stop offset="0.8624" stopColor="#3F873F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="21.9168"
            y1="22.2613"
            x2="40.5549"
            y2="22.2613"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0919165" stopColor="#6ABF4B" />
            <stop offset="0.2871" stopColor="#64B749" />
            <stop offset="0.5984" stopColor="#52A044" />
            <stop offset="0.8624" stopColor="#3F873F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="21.9157"
            y1="27.6148"
            x2="40.5548"
            y2="27.6148"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0919165" stopColor="#6ABF4B" />
            <stop offset="0.2871" stopColor="#64B749" />
            <stop offset="0.5984" stopColor="#52A044" />
            <stop offset="0.8624" stopColor="#3F873F" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="21.9174"
            y1="30.0349"
            x2="40.5555"
            y2="30.0349"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0919165" stopColor="#6ABF4B" />
            <stop offset="0.2871" stopColor="#64B749" />
            <stop offset="0.5984" stopColor="#52A044" />
            <stop offset="0.8624" stopColor="#3F873F" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="43.2708"
            y1="15.0921"
            x2="31.6606"
            y2="38.6305"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3F873F" />
            <stop offset="0.3296" stopColor="#3F8B3D" />
            <stop offset="0.6367" stopColor="#3E9638" />
            <stop offset="0.9341" stopColor="#3DA92E" />
            <stop offset="1" stopColor="#3DAE2B" />
          </linearGradient>
          <clipPath id="clip0">
            <rect width="111" height="33" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: 'Express',
    onHome: true,
    description:
      "Express est une librairie JavaScript qui vous permet de créer des serveurs logiciels afin d'y gérer la logique de votre site ou de votre application.",
    svg: (
      <svg width="112" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="evenodd" transform="translate(0 18)">
          <path
            d="M34.880068 25.0978467V.74788986h1.3218034v3.83053236a5.00846731 5.00846731 0 0 0 .4316093-.5395116c1.1026471-2.2888922 3.4301124-3.73304234 5.970595-3.70464631 3.0122731-.0899186 5.458059 1.02507203 6.8967566 3.70464631 1.8574378 3.37756169 1.9646623 7.44539358.2877395 10.91611798-1.3397871 3.0032813-4.6487916 4.49593-8.1915844 3.9474266-2.2401052-.1908129-4.2307018-1.5043359-5.2872137-3.4888417v9.6842332H34.880068zm1.3218034-15.73575497c.1168942 1.18692547.1618535 2.03216037.2967314 2.85941147.5215279 3.2550533 2.4457859 5.1883032 5.4670509 5.5389858 2.9253427.4808588 5.7829226-1.1719443 6.8248217-3.9474266 1.1744752-2.8005403 1.0893273-5.97066414-.2337884-8.70412044-1.1080083-2.47839885-3.7232299-3.9235564-6.4111961-3.54279284-2.5179834.182434-4.6438857 1.94018337-5.2962056 4.37903582a30.03281992 30.03281992 0 0 0-.6474139 3.41690679zM77.9330936 12.6710962c-.4142538 3.5459908-3.3900491 6.2372784-6.9596996 6.294302-5.5389858.2787477-8.1376333-3.3989231-8.5512589-7.643081-.2870887-2.30480359.087139-4.64372705 1.0790232-6.74389498 1.4174294-2.95610727 4.5853333-4.65462753 7.8319101-4.19919861 3.0846968.26144417 5.6561683 2.46711476 6.3842206 5.47604273a36.94756616 36.94756616 0 0 1 .6204383 4.04633699H63.779906c-.2697558 3.84851607 1.798372 6.94171587 4.7297183 7.68804027 3.6506952.899186 6.7708706-.6833813 7.903845-4.1542393.251772-.8901941.7103569-1.0160802 1.5196243-.7643081zM63.779906 8.66971851h13.0112214c-.0809268-4.10028815-2.634615-7.06760195-6.0964811-7.11256125-3.9204509-.06294302-6.743895 2.79646846-6.9147403 7.11256125z"
            fillRule="nonzero"
          />
          <path d="M80.6126679 12.7610148h1.2768441c.0961595 1.9154836 1.2555068 3.6163225 3.0032812 4.4060114 2.180735.9813641 4.6898802.9151597 6.8158299-.1798372 1.1714072-.5280888 1.8892966-1.7305534 1.798372-3.0122731.0675802-1.2400691-.6959779-2.3743934-1.8703069-2.7784847-1.4027301-.5215279-2.8953789-.8092674-4.3250846-1.26785229a31.69630381 31.69630381 0 0 1-4.3520603-1.59155922c-2.3019161-1.1239825-2.4457859-5.50301831.1618535-6.88776475 2.7130091-1.53098714 6.0172796-1.58176998 8.7760554-.1348779 1.6841481.93076894 2.6154083 2.80761656 2.3378836 4.71173464h-1.097007c0-.05395116-.0989104-.09891046-.0989104-.15286162-.1348779-3.49783354-3.0662243-4.57685674-6.2133753-4.2711335-.939489.11588759-1.8520073.39268482-2.697558.81825926-1.0410889.47610492-1.6682838 1.55747542-1.5645836 2.697558.003205 1.14039706.7231895 2.15557516 1.798372 2.53570451 1.3847464.50354416 2.8324359.82725112 4.2531498 1.22289296 1.1419662.3147151 2.3288917.52152788 3.4348905.899186 1.5981324.52387431 2.7070715 1.97980411 2.7874766 3.65968701.2737027 1.8439273-.6648293 3.6557651-2.3288918 4.49593-3.0032812 1.6994615-7.9488042 1.2498685-10.1518099-.899186-1.1277132-1.134164-1.7557072-2.6717781-1.7444208-4.2711335zM111.023138 6.02611168h-1.195917c0-.16185348-.062943-.30572324-.080927-.44060114-.03998-1.84748132-1.367441-3.41493572-3.183118-3.75859748-1.662315-.47694355-3.435605-.39159806-5.044434.24278022-1.306014.37447749-2.2098677 1.56375805-2.2209891 2.9223545-.0460877 1.33925126.8555551 2.52641397 2.1580461 2.84142775 1.798372.55749532 3.641704.899186 5.467051 1.40273016.591512.14197288 1.174021.31912784 1.744421.53051974 1.743201.62367787 2.925843 2.25218917 2.979513 4.10282217.053671 1.850633-1.032606 3.5449454-2.736733 4.2685995-2.565858 1.1651276-5.504028 1.1945093-8.092674.0809267-2.156167-.9299543-3.5052-3.1041937-3.3809391-5.4490671h1.1689418c.4390196 2.118109 1.8947243 3.8832654 3.8904993 4.7175353 1.995775.8342699 4.27464.6302308 6.090465-.5453123 1.112609-.5780318 1.786853-1.7509359 1.726437-3.0032812.055666-1.2408014-.718937-2.3678305-1.897282-2.7605011-1.40273-.5215278-2.895379-.8002755-4.325085-1.25886035-1.496084-.41708158-2.959665-.94300923-4.3790355-1.5735755-2.247965-1.10599878-2.4278022-5.44906715.1348779-6.83381359 2.7496926-1.596877 6.1354986-1.6344212 8.9199246-.09891046 1.599547.95487037 2.484673 2.76391346 2.256957 4.61282418zM32.695046 18.5247971c-.9743287.3689381-2.0707079-.0479948-2.5536882-.9711209-1.4656732-2.1940139-3.084208-4.2891172-4.6397998-6.4291799l-.6743895-.899186c-1.8523231 2.4817533-3.7046463 4.8645962-5.395116 7.3373577-.4555797.8817604-1.4940184 1.2894438-2.4278022.9531372l6.9507078-9.32455881-6.4651473-8.4253728c.9593725-.34640866 2.0300847.02927984 2.5626801.89918599 1.5016406 2.19401384 3.1651347 4.28911722 4.8196369 6.51010663 1.6634941-2.20300569 3.3090045-4.30710093 4.8466126-6.48313105.4584415-.86812496 1.4947545-1.25480893 2.4098184-.899186l-2.5087289 3.3269882c-1.1239825 1.4836569-2.2299813 2.97630565-3.3989231 4.42399511-.1905018.17057319-.2993709.41418637-.2993709.66989357s.1088691.49932039.2993709.66989357c2.1490546 2.85041959 4.2801254 5.70983109 6.4741392 8.64117749zM62.2063305.67595498v1.2588604c-1.839111-.12062656-3.6433439.54286278-4.9661419 1.82625101-1.322798 1.28338823-2.0405374 3.06673472-1.975574 4.90865212v9.89104599h-1.285836V.74788986h1.2588604v3.65069516C56.7932308 1.73699446 59.1940574.74788987 62.2063305.67595499z" />
          <path
            d="M.35132565 9.07435221c.18882906-.899186.30572324-1.87929874.56648718-2.79646845C2.4734046.74788986 8.81266589-1.55402629 13.173718 1.87187236c2.5536882 2.00518478 3.1921103 4.84661254 3.0662242 8.04771469H1.85296627C1.61917791 15.63841 5.74644164 19.0912842 11.0246635 17.3288797c1.7393863-.6221812 3.047841-2.0794007 3.4798498-3.8754917.2787476-.899186.7283406-1.0520476 1.5825673-.7912837-.2850818 2.21786-1.5707409 4.1827977-3.4888417 5.332173-3.20874864 1.7546833-7.18202466 1.2466845-9.84608664-1.2588604C1.46735667 15.2908281.69050298 13.4655377.54015471 11.5381218c0-.3057232-.11689418-.6114464-.1798372-.899186-.00599458-.533517-.00899186-1.05504486-.00899186-1.56458359zm1.51962434-.38664998H14.8821714c-.0809268-4.14524745-2.697558-7.08558567-6.18639969-7.11256125-3.88448351-.05395116-6.66296824 2.82344404-6.83381358 7.09457753l.00899186.01798372z"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'MongoDB',
    onHome: true,
    description: 'MongoDB est un système de gestion de base de données NoSQL (Not Only SQL).',
    svg: (
      <svg width="25" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            d="M23.0332131 17.6217049c.7104099 2.0550984 1.222082 4.1531312 1.3902787 6.3277377.208918 2.6977869.1133115 5.376541-.455459 8.0300656-.0154918.0730328-.0482459.1416393-.0725902.212459-.178377.0004426-.3602951-.0216885-.5346885.0053115-1.4734918.2314918-2.9456557.4713934-4.4178197.7099672-1.5217377.246541-3.0456885.4833443-4.5647705.7467049-.5382295.0929508-1.204377-.0181475-1.4217049.7263443-.0061967.0203606-.0681639.0239016-.1040164.0354098l.0734754-4.4488033c-.0252295-3.5781639-.0500164-7.1563278-.0748032-10.7344918l.7090819-.1217213c1.1596722-.1898852 2.3193443-.3824262 3.4799017-.567 1.3849672-.2199836 2.7712623-.4337705 4.1571147-.6484426.6112623-.0951639 1.2234099-.1823607 1.836-.273541z"
            fill="#439934"
          />
          <path
            d="M11.3882459 47.3845574c-.7480328-.6431312-1.52218033-1.2579344-2.23922951-1.9342623-3.85834426-3.6392459-6.68050819-7.9225082-8.07034426-13.0865902-.38286885-1.4212623-.6382623-2.865541-.72014754-4.3341639-.05754098-1.0277705-.1407541-2.0648361-.06816393-3.0872951.19342623-2.7194754.5864754-5.4128361 1.38408196-8.0322787l.04381968-.061082c.07745901.1031312.189.1943115.22839344.3107214.77857377 2.2927868 1.55139344 4.5873442 2.32022951 6.8832295 2.41583606 7.2147541 4.82857377 14.4312787 7.24839345 21.6442623.0473606.1407541.1699672.2562786.2580492.3833114l-.385082 1.3141476z"
            fill="#45A538"
          />
          <path
            d="M23.0332131 17.6217049c-.6125901.0911803-1.2251803.1783771-1.8364426.2726558-1.3858525.2146721-2.7721475.428459-4.1571148.6484426-1.1605573.1845737-2.3202295.3771147-3.4799016.567l-.709082.1217213-.0053114-.462541c-.0234591-.3802131-.0637377-.7599836-.068164-1.1401967-.030541-2.4246885-.0495737-4.8493771-.0796721-7.2740656-.0185902-1.51775409-.0464754-3.03506556-.077459-4.55237704-.0190328-.94278688-.0393935-1.88601639-.0818853-2.82747541-.0230164-.50591803-.104459-1.00918033-.1376557-1.51509836-.0185902-.29080328.007082-.58381967.0128361-.87595082.3616229.70067213.7152786 1.40665574 1.0870819 2.1020164.5873607 1.09947541 1.5230656 1.90947541 2.3653771 2.79339344 3.3298524 3.49318033 5.6939016 7.55468849 7.1673934 12.14247539z"
            fill="#46A037"
          />
          <path
            d="M12.852 34.4152623c.0358525-.0115082.0982623-.0150492.1040164-.0354098.2173279-.7444918.8834754-.6333935 1.4217049-.7263443 1.519082-.262918 3.0430328-.5001639 4.5647705-.7467049 1.4721639-.2385738 2.9443279-.4784754 4.4178197-.7099672.1743934-.0274427.3563115-.0048689.5346885-.0053115-.2753115.9826229-.4921967 1.9864918-.8414262 2.9421147-.3965902 1.0839837-.8763935 2.1418525-1.3858525 3.1789181-.7613115 1.5505082-1.7098524 2.9965574-2.8119836 4.3213278-.8493934 1.0215738-1.7961639 1.9656886-2.7451475 2.8982951-.5245082.5156558-1.1428525.9357049-1.7182623 1.3991312l-.149164-.1018033-.5373442-.4594426-.5559345-1.218541c-.3828688-1.4265738-.5838196-2.8788197-.6170163-4.3545246l.0101803-.2483115.0756885-1.0738033c.0252295-.3664918.0588689-.7325409.0743607-1.099918.0570983-1.3199016.1066721-2.6398033.1589016-3.9597049z"
            fill="#409433"
          />
          <path
            d="M12.852 34.4152623c-.0522295 1.3199016-.1018033 2.6398033-.1580164 3.9601475-.0154918.3673771-.0491311.7334263-.0743606 1.0999181l-.3386066.127918c-.7520164-2.214-1.5044754-4.404541-2.2405574-6.6008361-1.2172131-3.6334918-2.41981966-7.2727377-3.63526228-10.9071147-.98129508-2.9337049-1.97055738-5.8643115-2.96557377-8.7935902-.04647541-.1372131-.18014754-.2443279-.27309836-.3656065l2.16708197-3.98449184c.07436065.1292459.17262295.25008196.21954098.38906557C6.55568852 12.3075738 7.55645902 15.274918 8.54881967 18.2453607c1.29068853 3.8640983 2.57340983 7.731295 3.86321313 11.595836.0513442.1544754.1363279.297.2173279.4700656l.2965573-.3452459c-.0247869 1.4832295-.0495737 2.9660164-.073918 4.4492459z"
            fill="#4FAA41"
          />
          <path
            d="M3.16696721 12.936541c.09295082.1212787.22618033.2283934.27309836.3656065.9950164 2.9292787 1.98427869 5.8598853 2.96557377 8.7935902 1.21544263 3.6343771 2.41804918 7.273623 3.63526226 10.9071148.7356394 2.1958524 1.4880984 4.386836 2.2405574 6.600836l.3386066-.127918-.0756886 1.0738033-.0686065.2474262c-.1177377 1.1756066-.2168853 2.3538689-.3602951 3.5268197-.0721475.5878033-.2252951 1.1649836-.3417049 1.7470328-.0876394-.1270328-.2106885-.2425574-.2580492-.3833115-2.41981966-7.2134262-4.83255737-14.4295082-7.24839343-21.6442623-.76883607-2.2958853-1.54165574-4.5904426-2.32022951-6.8832295-.03939344-.1164099-.1504918-.2075902-.22839344-.3107213.48245901-1.3044099.96536065-2.6088197 1.44826229-3.9127869z"
            fill="#4AA73C"
          />
          <path
            d="M12.9254754 29.966459l-.2965574.3452459c-.081-.1730656-.1659836-.3160328-.2173278-.4700656-1.2893607-3.8645409-2.57252463-7.7317377-3.86321315-11.595836-.99236066-2.9704426-1.99313115-5.9377869-2.99567213-8.90468855-.04647541-.1389836-.14473771-.26026229-.21954099-.38906557l2.68008197-3.5254918c.08454099.11286885.20493443.21334426.2487541.34037705.74404918 2.17814754 1.48145902 4.35895077 2.2144426 6.54108197.6847377 2.0378361 1.3592951 4.0787705 2.052 6.1139508.0464754.1363279.2080328.2328197.3160328.3479017l.0053115.4625409c.0256721 3.5772787.0509016 7.1558853.0756885 10.7340492z"
            fill="#57AE47"
          />
          <path
            d="M12.8453607 18.7689836c-.108-.115082-.2695574-.2115738-.3160328-.3479016-.6927049-2.0351804-1.3672623-4.0761148-2.052-6.1139509C9.74434426 10.125 9.00693443 7.94463934 8.26288525 5.76604918c-.04381968-.12703279-.16421312-.2275082-.2487541-.34037705.87152459-.85337705 1.71604918-1.73729508 2.62254095-2.55127869.8060164-.7232459 1.4540164-1.49872131 1.4836722-2.64157377.0013278-.04736065.0261147-.0947213.0641803-.2275082l.2297213.57806558c-.0057541.29257377-.0318689.58514754-.0128361.87595082.0331968.50591803.1146394 1.00918033.1376558 1.51509836.0424918.94145902.0628524 1.88468852.0818852 2.82747541.030541 1.51731147.0584262 3.03462295.077459 4.55237706.0296558 2.4246885.0491312 4.849377.0796722 7.2740656.003541.3810983.043377.7604262.0672787 1.1406393z"
            fill="#60B24F"
          />
          <path
            d="M11.7728852 46.0704098c.1164099-.5820491.2695574-1.1596721.341705-1.7470328.1438524-1.1725081.2425573-2.3512131.360295-3.5268196l.0292132-.0044263.0292131.0048689c.0331967 1.4757049.2341475 2.9279508.6170164 4.3545246-.0779017.1026885-.1881148.1943115-.2292787.3102787-.3217869.907377-.6249836 1.821836-.948541 2.7292131-.0442623.1239344-.1673115.2204262-.2540656.3293115l-.3306393-1.1357705.3850819-1.3141476z"
            fill="#A9AA88"
          />
          <path
            d="M11.7188852 48.5207705c.0867541-.1088853.2102459-.2053771.2540656-.3293115.3235574-.907377.6271967-1.8213934.948541-2.7292131.0411639-.1159672.1509344-.2075902.2292787-.3102787l.5554918 1.2189836c-.1097705.1558033-.2611475.2961148-.3222295.469623l-1.0640656 3.1244754c-.0438197.1252623-.1934262.2137869-.293459.3195738l-.307623-1.7638525z"
            fill="#B6B598"
          />
          <path
            d="M12.0265082 50.2841803c.1004754-.1053442.2496393-.1943114.293459-.3195737l1.0640656-3.1244755c.0606393-.1730655.212459-.3138196.3222295-.4696229l.5377869.459c-.2598197.2567213-.4041148.5532787-.3173607.9281803l-.1633278.5346885c-.0743607.091623-.1819181.1712951-.2186558.2761968-.3713606 1.0636229-.7259016 2.133-1.099918 3.1966229-.0473607.135-.1788197.2407869-.2717705.3594099-.0482459-.6139181-.0973771-1.2265082-.1465082-1.8404263z"
            fill="#C2C1A7"
          />
          <path
            d="M12.173459 52.1246066c.0925082-.1190656.2239672-.2248525.2717705-.3594099.3740164-1.0631803.7285574-2.1325574 1.099918-3.1966229.0367377-.104459.1438525-.1845738.2186558-.2761968l-.2252951 2.4543443c-.0601967.0694918-.1473934.1301312-.1761639.2111312-.2545082.7143934-.4944099 1.4340983-.7498033 2.1484918-.0526721.1473934-.1535902.2775246-.2323771.4151803-.0699344-.091623-.1951967-.1801476-.2009508-.2757541-.0225738-.3722459-.007082-.7471475-.0057541-1.1211639z"
            fill="#CECDB7"
          />
          <path
            d="M12.3797213 53.5215246c.0787869-.1380984.1797049-.2682295.2323771-.4151803.255836-.7139509.495295-1.4336558.7498032-2.1484918.0287705-.081.1164099-.1411968.176164-.2111312l.0053114 1.6111476-.5391147 1.3827541-.624541-.2190984z"
            fill="#DBDAC7"
          />
          <path
            fill="#EBE9DC"
            d="M13.0042623 53.7410656l.5391147-1.3827541.1110984 1.6359344-.6502131-.2531803z"
          />
          <path
            d="M13.9266885 47.7581311c-.0867541-.3749016.0570984-.6719016.3173607-.9281803l.1491639.1018033-.4665246.826377z"
            fill="#CECDB7"
          />
          <path
            fill="#4FAA41"
            d="M12.5333115 40.7974426l-.0292131-.0048688-.0292132.0044262.0686066-.2474262-.0101803.2478688z"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'PostgreSQL',
    onHome: true,
    description:
      'PostgreSQL est une base de données relationnelle open-source, puissante et fiable, adaptée aux applications de toutes tailles.',
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 25.6 25.6" width="64">
        <g fill="none" stroke="#fff">
          <path
            d="M18.983 18.636c.163-1.357.114-1.555 1.124-1.336l.257.023c.777.035 1.793-.125 2.4-.402 1.285-.596 2.047-1.592.78-1.33-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.227-11.687-3.004-3.84-8.205-2.024-8.292-1.976l-.028.005c-.57-.12-1.2-.19-1.93-.2-1.308-.02-2.3.343-3.054.914 0 0-9.277-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.01 2.01 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.285 1.76.33 2.842s.116 2.093.337 2.688.48 2.13 2.53 1.7c1.713-.367 3.023-.896 3.143-5.81"
            fill="#000"
            stroke="#000"
            strokeLinecap="butt"
            strokeWidth="2.149"
            className="D"
          />
          <path
            d="M23.535 15.6c-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.228-11.687-3.004-3.84-8.205-2.023-8.292-1.976l-.028.005a10.31 10.31 0 0 0-1.929-.201c-1.308-.02-2.3.343-3.054.914 0 0-9.278-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.02 2.02 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.52 1.593.484 2.815s-.06 2.06.18 2.716.48 2.13 2.53 1.7c1.713-.367 2.6-1.32 2.725-2.906.088-1.128.286-.962.3-1.97l.16-.478c.183-1.53.03-2.023 1.085-1.793l.257.023c.777.035 1.794-.125 2.39-.402 1.285-.596 2.047-1.592.78-1.33z"
            fill="#336791"
            stroke="none"
          />
          <g className="E">
            <g className="B">
              <path
                d="M12.814 16.467c-.08 2.846.02 5.712.298 6.4s.875 2.05 2.926 1.612c1.713-.367 2.337-1.078 2.607-2.647l.633-5.017M10.356 2.2S1.072-1.596 1.504 7.033c.092 1.836 2.63 13.9 5.66 10.25C8.27 15.95 9.27 14.907 9.27 14.907m6.1-13.4c-.32.1 5.164-2.005 8.282 1.978 1.1 1.407-.175 7.157-3.228 11.687"
                className="C"
              />
              <path
                d="M20.425 15.17s.2.98 3.1.382c1.267-.262.504.734-.78 1.33-1.054.49-3.418.615-3.457-.06-.1-1.745 1.244-1.215 1.147-1.652-.088-.394-.69-.78-1.086-1.744-.347-.84-4.76-7.29 1.224-6.333.22-.045-1.56-5.7-7.16-5.782S7.99 8.196 7.99 8.196"
                strokeLinejoin="bevel"
              />
            </g>
            <g className="C">
              <path d="M11.247 15.768c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.163.35-.49-.002-1.27-.482-1.468-.232-.096-.542-.216-.94.23z" />
              <path
                d="M11.196 15.753c-.08-.513.168-1.122.433-1.836.398-1.07 1.316-2.14.582-5.537-.547-2.53-4.22-.527-4.22-.184s.166 1.74-.06 3.365c-.297 2.122 1.35 3.916 3.246 3.733"
                className="B"
              />
            </g>
          </g>
          <g fill="#fff" className="D">
            <path
              d="M10.322 8.145c-.017.117.215.43.516.472s.558-.202.575-.32-.215-.246-.516-.288-.56.02-.575.136z"
              strokeWidth=".239"
            />
            <path
              d="M19.486 7.906c.016.117-.215.43-.516.472s-.56-.202-.575-.32.215-.246.516-.288.56.02.575.136z"
              strokeWidth=".119"
            />
          </g>
          <path
            d="M20.562 7.095c.05.92-.198 1.545-.23 2.524-.046 1.422.678 3.05-.413 4.68"
            className="B C E"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'Raspbian',
    onHome: true,
    description:
      "Raspbian est un système d'exploitation libre et open-source pour les Raspberry Pi.",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 720" height="70" width="70">
        <path
          fill="#000"
          d="m158.38,1.6562c-3.6193,0.11232-7.5172,1.4493-11.938,4.9375-10.83-4.1763-21.33-5.6271-30.72,2.8751-14.5-1.8808-19.212,2.0002-22.782,6.5312-3.183-0.066-23.819-3.272-33.282,10.844-23.781-2.814-31.297,13.988-22.781,29.656-4.8569,7.519-9.8895,14.947,1.4688,29.281-4.018,7.9835-1.5274,16.644,7.9375,27.125-2.4979,11.223,2.4121,19.141,11.219,25.312-1.6471,15.358,14.084,24.287,18.781,27.469,1.8037,8.9487,5.5629,17.393,23.531,22.062,2.9632,13.336,13.762,15.639,24.219,18.438-34.562,20.09-64.201,46.523-64,111.38l-5.0625,9.0312c-39.63,24.1-75.285,101.56-19.53,164.52,3.6419,19.708,9.7496,33.864,15.188,49.531,8.1338,63.131,61.218,92.692,75.219,96.188,20.517,15.628,42.368,30.457,71.938,40.844,27.875,28.749,58.074,39.706,88.438,39.688,0.44515-0.00028,0.89853,0.005,1.3438,0,30.364,0.0189,60.562-10.938,88.438-39.688,29.569-10.387,51.421-25.216,71.938-40.844,14.001-3.4959,67.085-33.057,75.219-96.188,5.4379-15.667,11.546-29.823,15.188-49.531,55.754-62.965,20.1-140.43-19.531-164.53l-5.07-9.03c0.20067-64.852-29.438-91.285-64-111.38,10.457-2.7984,21.256-5.1014,24.219-18.438,17.968-4.6698,21.728-13.114,23.531-22.062,4.6978-3.1813,20.428-12.111,18.781-27.469,8.8067-6.1716,13.717-14.09,11.219-25.312,9.4649-10.481,11.956-19.141,7.9375-27.125,11.36-14.328,6.32-21.756,1.47-29.275,8.51-15.668,1-32.47-22.79-29.656-9.46-14.116-30.09-10.91-33.28-10.844-3.57-4.531-8.28-8.412-22.78-6.5312-9.39-8.5022-19.89-7.0514-30.72-2.875-12.86-10.148-21.37-2.0133-31.09,1.0624-15.57-5.0877-19.13,1.881-26.78,4.7188-16.98-3.5881-22.14,4.224-30.28,12.469l-9.4688-0.1875c-25.611,15.093-38.334,45.826-42.844,61.625-4.5121-15.802-17.206-46.535-42.812-61.625l-9.4688,0.1875c-8.15-8.245-13.31-16.057-30.29-12.469-7.65-2.8378-11.2-9.8065-26.78-4.7188-6.3797-2.0185-12.247-6.2144-19.156-6z"
        />
        <path
          fill="#75a928"
          d="m107.39,68.056c67.948,35.031,107.45,63.369,129.09,87.504-11.082,44.418-68.896,46.445-90.036,45.199,4.3284-2.0147,7.9399-4.4278,9.2205-8.1357-5.3045-3.7698-24.113-0.39719-37.244-7.7742,5.0441-1.045,7.4035-2.063,9.7629-5.7854-12.406-3.9567-25.769-7.3664-33.628-13.921,4.2413,0.0524,8.2012,0.9488,13.74-2.8927-11.112-5.9882-22.969-10.734-32.181-19.887,5.7452-0.14063,11.939-0.0568,13.74-2.1695-10.17-6.3007-18.751-13.308-25.854-20.972,8.04,0.97052,11.435,0.13478,13.379-1.2656-7.6878-7.8742-17.418-14.523-22.057-24.226,5.9696,2.0575,11.431,2.8451,15.368-0.1808-2.6124-5.8935-13.805-9.3696-20.249-23.142,6.2844,0.60938,12.95,1.3711,14.283,0-2.917-11.884-7.922-18.565-12.831-25.487,13.45-0.2,33.828,0.052,32.905-1.085l-8.3165-8.4973c13.138-3.5372,26.581,0.56816,36.34,3.6159,4.3819-3.4577-0.0776-7.83-5.4238-12.294,11.165,1.4906,21.254,4.0574,30.373,7.5934,4.8724-4.3993-3.1639-8.7987-7.051-13.198,17.249,3.2726,24.557,7.8707,31.82,12.475,5.2694-5.0508,0.30166-9.3433-3.2543-13.74,13.006,4.817,19.705,11.036,26.758,17.175,2.3912-3.2271,6.0749-5.5924,1.6272-13.379,9.2342,5.3227,16.189,11.595,21.334,18.622,5.7134-3.6379,3.4039-8.613,3.4351-13.198,9.5966,7.8065,15.687,16.114,23.142,24.226,1.5017-1.0934,2.8166-4.8017,3.9775-10.667,22.895,22.212,55.246,78.158,8.3165,100.34-39.94-32.94-87.64-56.883-140.5-74.844z"
        />
        <path
          fill="#75a928"
          d="M467.92,68.056c-67.94,35.034-107.44,63.364-129.08,87.504,11.082,44.418,68.896,46.445,90.036,45.199-4.3284-2.0147-7.9399-4.4278-9.2205-8.1357,5.3045-3.7698,24.113-0.39719,37.244-7.7742-5.0441-1.045-7.4035-2.063-9.7629-5.7854,12.406-3.9567,25.769-7.3664,33.628-13.921-4.2413,0.0524-8.2012,0.9488-13.74-2.8927,11.112-5.9882,22.969-10.734,32.181-19.887-5.7452-0.14063-11.939-0.0568-13.74-2.1695,10.17-6.3007,18.751-13.308,25.854-20.972-8.04,0.97052-11.435,0.13478-13.379-1.2656,7.6878-7.8742,17.418-14.523,22.057-24.226-5.9696,2.0575-11.431,2.8451-15.368-0.1808,2.6124-5.8935,13.805-9.3696,20.249-23.142-6.2844,0.60938-12.95,1.3711-14.283,0,2.9223-11.889,7.9275-18.57,12.836-25.492-13.45-0.19973-33.828,0.05235-32.905-1.0848l8.3165-8.4973c-13.138-3.5372-26.581,0.56816-36.34,3.6159-4.3819-3.4577,0.0776-7.83,5.4238-12.294-11.165,1.4906-21.254,4.0574-30.373,7.5934-4.8724-4.3993,3.1639-8.7987,7.051-13.198-17.249,3.2726-24.557,7.8707-31.82,12.475-5.2694-5.0508-0.30166-9.3433,3.2543-13.74-13.006,4.817-19.705,11.036-26.758,17.175-2.3912-3.2271-6.0749-5.5924-1.6272-13.379-9.2342,5.3227-16.189,11.595-21.334,18.622-5.7134-3.6379-3.4039-8.613-3.4351-13.198-9.5966,7.8065-15.687,16.114-23.142,24.226-1.5017-1.0934-2.8166-4.8017-3.9775-10.667-22.895,22.212-55.246,78.158-8.3165,100.34,39.919-32.947,87.616-56.888,140.48-74.849z"
        />
        <path
          fill="#bc1142"
          d="m365.2,521.85a71.956,66.532,0,1,1,-143.91,0,71.956,66.532,0,1,1,143.91,0z"
          transform="matrix(1.131107,0,0,1.1280497,-43.139135,-68.310983)"
        />
        <path
          fill="#bc1142"
          d="m262.84,276.65a61.875,28.125,0,1,1,-123.75,0,61.875,28.125,0,1,1,123.75,0z"
          transform="matrix(0.76741684,-1.1613112,2.171115,1.4224368,-560.88858,217.68859)"
        />
        <path
          fill="#bc1142"
          d="m262.84,276.65a61.875,28.125,0,1,1,-123.75,0,61.875,28.125,0,1,1,123.75,0z"
          transform="matrix(-0.76741684,-1.1613112,-2.171115,1.4224368,1134.8288,213.68859)"
        />
        <path
          fill="#bc1142"
          d="M72.91,342.09c36.41-9.76,12.292,150.63-17.333,137.47-32.587-26.21-43.083-102.97,17.333-137.47z"
        />
        <path
          fill="#bc1142"
          d="m493.68,340.09c-36.414-9.7569-12.292,150.64,17.333,137.48,32.587-26.213,43.083-102.98-17.333-137.48z"
        />
        <path
          fill="#bc1142"
          d="m369.97,220.65c62.835-10.61,115.12,26.722,113.01,94.858-2.0669,26.121-136.16-90.969-113.01-94.858z"
        />
        <path
          fill="#bc1142"
          d="M196.36,218.65c-62.84-10.61-115.12,26.73-113.01,94.86,2.067,26.12,136.16-90.97,113.01-94.86z"
        />
        <path
          fill="#bc1142"
          d="m286.62,202.76c-37.503-0.97548-73.495,27.834-73.582,44.544-0.10462,20.304,29.651,41.093,73.837,41.62,45.123,0.32321,73.916-16.64,74.061-37.594,0.16484-23.74-41.039-48.937-74.317-48.571z"
        />
        <path
          fill="#bc1142"
          d="m288.91,619.12c32.697-1.4271,76.571,10.532,76.657,26.396,0.5427,15.405-39.79,50.211-78.826,49.538-40.427,1.7439-80.069-33.116-79.55-45.199-0.60506-17.716,49.226-31.548,81.719-30.735z"
        />
        <path
          fill="#bc1142"
          d="m168.14,525.1c23.279,28.046,33.891,77.319,14.464,91.844-18.379,11.088-63.012,6.5216-94.736-39.052-21.395-38.242-18.638-77.157-3.6159-88.589,22.464-13.684,57.173,4.799,83.889,35.797z"
        />
        <path
          fill="#bc1142"
          d="m405.02,516.21c-25.187,29.502-39.212,83.31-20.838,100.64,17.568,13.464,64.729,11.582,99.566-36.756,25.296-32.465,16.82-86.682,2.3708-101.08-21.464-16.602-52.277,4.6449-81.099,37.188z"
        />
      </svg>
    ),
  },
  {
    name: 'Home Assistant',
    onHome: true,
    description: 'Home Assistant est un outil open-source pour la maison connectée.',
    svg: (
      <svg
        viewBox="80 87 240 230"
        height="60"
        width="60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M320 301.762C320 310.012 313.25 316.762 305 316.762H95C86.75 316.762 80 310.012 80 301.762V211.762C80 203.512 84.77 191.993 90.61 186.153L189.39 87.3725C195.22 81.5425 204.77 81.5425 210.6 87.3725L309.39 186.162C315.22 191.992 320 203.522 320 211.772V301.772V301.762Z"
          fill="#F2F4F9"
        />
        <path
          d="M309.39 186.153L210.61 87.3725C204.78 81.5425 195.23 81.5425 189.4 87.3725L90.61 186.153C84.78 191.983 80 203.512 80 211.762V301.762C80 310.012 86.75 316.762 95 316.762H187.27L146.64 276.132C144.55 276.852 142.32 277.262 140 277.262C128.7 277.262 119.5 268.062 119.5 256.762C119.5 245.462 128.7 236.262 140 236.262C151.3 236.262 160.5 245.462 160.5 256.762C160.5 259.092 160.09 261.322 159.37 263.412L191 295.042V179.162C184.2 175.822 179.5 168.842 179.5 160.772C179.5 149.472 188.7 140.272 200 140.272C211.3 140.272 220.5 149.472 220.5 160.772C220.5 168.842 215.8 175.822 209 179.162V260.432L240.46 228.972C239.84 227.012 239.5 224.932 239.5 222.772C239.5 211.472 248.7 202.272 260 202.272C271.3 202.272 280.5 211.472 280.5 222.772C280.5 234.072 271.3 243.272 260 243.272C257.5 243.272 255.12 242.802 252.91 241.982L209 285.892V316.772H305C313.25 316.772 320 310.022 320 301.772V211.772C320 203.522 315.23 192.002 309.39 186.162V186.153Z"
          fill="#18BCF2"
        />
      </svg>
    ),
  },
  {
    name: 'Git',
    onHome: true,
    description: 'Git est un logiciel libre de gestion de versions décentralisé.',
    svg: (
      <svg width="51" height="54" xmlns="http://www.w3.org/2000/svg">
        <path d="M.34165385 22.865625c0 3.0495536 1.97671153 7.2321429 5.06379807 8.2566964v.1205357c-2.29396154 1.0004465-2.92846154 6.0991072.12201923 7.93125v.1205358C2.19634615 40.3794643 0 42.4647321 0 46.06875 0 52.2763393 5.95453846 54 11.1647596 54c6.345 0 11.0671442-2.2540179 11.0671442-9.1607143 0-8.4977678-12.32394226-5.3638393-12.32394226-9.9803571 0-1.6272322.87853846-2.2540179 2.40377886-2.5674107 5.0637981-.928125 8.2362981-4.8214286 8.2362981-9.9080358 0-.8799107-.1830289-1.7116071-.488077-2.53125.8175289-.1808035 1.6106539-.3977678 2.4037789-.6629464v-6.0870536c-2.0987308.8196429-4.3560866 1.4223215-6.6500481 1.4223215C9.24905769 10.7879464.34165385 14.68125.34165385 22.865625zm10.70108655 19.74375c2.0743269 0 5.0271923.3616071 5.0271923 3.0133929 0 2.6276785-2.379375 3.1700892-4.600125 3.1700892-2.1109327 0-5.2834327-.3254464-5.2834327-3.0375.01220192-2.6879464 2.696625-3.1459821 4.8563654-3.1459821zM10.6522788 27c-2.68442303 0-3.81920188-1.5669643-3.81920188-4.0741071 0-5.9424108 7.44317308-5.8821429 7.44317308-.0602679C14.27625 25.3125 13.3000962 27 10.6522788 27zM50.76 32.9665179v5.90625c-1.6228558.8799107-3.7215865 1.18125-5.551875 1.18125-6.5280288 0-7.29675-5.0866072-7.29675-10.3299108V19.153125h.0610096v-.1205357c-.8541346 0-.8907404-.1928572-2.9284615.1205357v-5.7254464h2.9284615c0-2.6879465.0366058-3.73660717-.1830288-4.96607146h6.9184904c-.2440385 1.66339286-.1830289 3.31473216-.1830289 4.96607146h6.2229808v5.7254464s-2.3549712-.1205357-6.2229808-.1205357v10.9808036c0 1.7839285.4026635 3.9535714 2.6600192 3.9535714 1.1957885 0 2.5990097-.3375 3.5751635-1.0004464zM32.9451923 4.42366071c0 2.25401786-1.7692788 4.36339286-4.12425 4.36339286-2.4159808 0-4.2096635-2.07321428-4.2096635-4.36339286C24.6112788 2.09732143 26.3805577 0 28.8209423 0c2.4159808 0 4.12425 2.16964286 4.12425 4.42366071zm-.7565192 8.97991069c-.2196346 1.7598215-.1952308 24.0830357 0 26.2526786h-6.7720673c.1952307-2.1816964.2196346-24.46875 0-26.2526786h6.7720673z" />
      </svg>
    ),
  },
  {
    name: 'Github',
    onHome: true,
    description:
      "Github est un service Web d'hébgergement et de gestion de développement de logiciels, utilisant le logiciel de gestion de versions Git.",
    svg: (
      <svg width="57" height="54" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.8469846 43.480721c0 .2233217-.2612904.401979-.5907434.401979-.3748948.0334982-.6361851-.1451591-.6361851-.401979 0-.2233216.2612903-.4019789.5907433-.4019789.3408135-.0334982.6361852.1451591.6361852.4019789zm-3.5330996-.5024736c-.0795231.2233216.1476858.4801415.4884993.547138.2953717.1116608.6361851 0 .7043478-.2233217.0681627-.2233216-.1476858-.4801415-.4884993-.5806362-.2953716-.0781626-.6248247.0334982-.7043478.2568199zm5.0213184-.1898234c-.329453.0781626-.556662.2903181-.5225807.547138.0340814.2233216.329453.3684807.6702665.2903181.329453-.0781626.556662-.2903181.5225806-.5136398-.0340813-.2121555-.3408134-.3573146-.6702664-.3238163zM27.8103787 0C12.0534362 0 0 11.7578837 0 27.2452387c0 12.3831842 7.92959327 22.9797955 19.2559607 26.7092667 1.4541375.2568199 1.9653577-.6253006 1.9653577-1.3510959 0-.692297-.0340814-4.5110968-.0340814-6.8559739 0 0-7.9523141 1.6749122-9.6223001-3.3274923 0 0-1.2950912-3.2493297-3.15820478-4.0867858 0 0-2.60154278-1.7530748.18176718-1.7195765 0 0 2.8287518.2233216 4.3851332 2.880849 2.4879383 4.3101074 6.657223 3.0706724 8.2817672 2.333711.2612903-1.786573.9997195-3.0260081 1.8176718-3.7629695-6.3504909-.692297-12.757784-1.5967496-12.757784-12.3385199 0-3.0706724.8633941-4.6115916 2.6810659-6.576822-.2953716-.7257953-1.2610098-3.7183051.2953717-7.5817693 2.3743338-.7257952 7.8387097 3.014842 7.8387097 3.014842 2.2720897-.6253005 4.7145862-.9491169 7.1343618-.9491169 2.4197756 0 4.8622721.3238164 7.1343619.9491169 0 0 5.4643759-3.7518033 7.8387097-3.014842 1.5563814 3.8746303.5907433 6.855974.2953716 7.5817693 1.8176718 1.9763964 2.9309958 3.5173157 2.9309958 6.576822 0 10.7752685-6.6913043 11.6350568-13.0417952 12.3385199 1.0451613.8821205 1.9312763 2.5570327 1.9312763 5.1810618 0 3.7629695-.0340814 8.4192254-.0340814 9.3348441 0 .7257953.5225807 1.6079157 1.9653577 1.3510958 11.3604488-3.707139 19.0628331-14.3037503 19.0628331-26.6869345C56.3478261 11.7578837 43.5673212 0 27.8103787 0zM11.0423562 38.5118148c-.1476858.1116608-.1136044.3684807.0795232.5806362.1817672.1786573.4430575.2568199.5907433.1116608.1476859-.1116608.1136045-.3684806-.0795231-.5806362-.1817672-.1786573-.4430575-.2568199-.5907434-.1116608zm-1.22692843-.9044526c-.07952314.1451591.03408135.3238164.26129033.4354772.1817672.1116608.4089761.0781626.4884993-.0781626.0795231-.145159-.0340814-.3238163-.2612903-.4354772-.227209-.0669965-.40897619-.0334982-.48849933.0781626zm3.68078543 3.975125c-.1817672.145159-.1136045.4801415.1476858.692297.2612903.2568199.5907434.2903182.7384292.1116609.1476858-.1451591.0795231-.4801415-.1476858-.6922971-.2499299-.2568199-.5907434-.2903181-.7384292-.1116608zm-1.2950912-1.641414c-.1817672.1116608-.1817672.401979 0 .6587988.1817672.2568199.4884993.3684807.6361852.2568199.1817671-.1451591.1817671-.4354772 0-.692297-.1590463-.2568199-.454418-.3684807-.6361852-.2233217z"
          fill="#000000"
        />
      </svg>
    ),
  },
  {
    name: 'Netlify',
    onHome: true,
    description:
      'Netlify est une plateforme qui permet de déployer des applications/sites “statiques” très simplement.',
    svg: (
      <svg height="57" viewBox="0 0 512 209" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_235_8)">
          <path
            d="M117.436 207.036V154.604L118.529 153.51H129.452L130.545 154.604V207.036L129.452 208.13H118.529L117.436 207.036Z"
            fill="#05BDBA"
          />
          <path
            d="M117.436 53.5225V1.09339L118.529 0H129.452L130.545 1.09339V53.5225L129.452 54.6159H118.529L117.436 53.5225Z"
            fill="#05BDBA"
          />
          <path
            d="M69.9539 169.238H68.4094L60.6869 161.512V159.967L78.7201 141.938L86.8976 141.942L87.9948 143.031V151.209L69.9539 169.238Z"
            fill="#05BDBA"
          />
          <path
            d="M69.9462 38.8917H68.4017L60.6792 46.6181V48.1626L78.7124 66.192L86.8899 66.1882L87.9871 65.0986V56.9212L69.9462 38.8917Z"
            fill="#05BDBA"
          />
          <path
            d="M1.09339 97.5104H75.3711L76.4645 98.6038V109.526L75.3711 110.62H1.09339L0 109.526V98.6038L1.09339 97.5104Z"
            fill="#05BDBA"
          />
          <path
            d="M440.999 97.5104H510.91L512.004 98.6038V109.526L510.91 110.62H436.633L435.539 109.526L439.905 98.6038L440.999 97.5104Z"
            fill="#05BDBA"
          />
          <path
            d="M212.056 108.727L210.963 109.821H177.079L175.986 110.914C175.986 113.101 178.173 119.657 186.916 119.657C190.196 119.657 193.472 118.564 194.566 116.377L195.659 115.284H208.776L209.869 116.377C208.776 122.934 203.313 132.774 186.916 132.774C168.336 132.774 159.589 119.657 159.589 104.357C159.589 89.0576 168.332 75.9408 185.822 75.9408C203.313 75.9408 212.056 89.0576 212.056 104.357V108.731V108.727ZM195.659 97.7971C195.659 96.7037 194.566 89.0538 185.822 89.0538C177.079 89.0538 175.986 96.7037 175.986 97.7971L177.079 98.8905H194.566L195.659 97.7971Z"
            fill="#014847"
          />
          <path
            d="M242.66 115.284C242.66 117.47 243.753 118.564 245.94 118.564H255.776L256.87 119.657V130.587L255.776 131.681H245.94C236.103 131.681 227.36 127.307 227.36 115.284V91.2368L226.266 90.1434H218.617L217.523 89.05V78.1199L218.617 77.0265H226.266L227.36 75.9332V66.0965L228.453 65.0031H241.57L242.663 66.0965V75.9332L243.757 77.0265H255.78L256.874 78.1199V89.05L255.78 90.1434H243.757L242.663 91.2368V115.284H242.66Z"
            fill="#014847"
          />
          <path
            d="M283.1 131.681H269.983L268.889 130.587V56.2636L269.983 55.1702H283.1L284.193 56.2636V130.587L283.1 131.681Z"
            fill="#014847"
          />
          <path
            d="M312.61 68.2871H299.493L298.399 67.1937V56.2636L299.493 55.1702H312.61L313.703 56.2636V67.1937L312.61 68.2871ZM312.61 131.681H299.493L298.399 130.587V78.1237L299.493 77.0304H312.61L313.703 78.1237V130.587L312.61 131.681Z"
            fill="#014847"
          />
          <path
            d="M363.98 56.2636V67.1937L362.886 68.2871H353.05C350.863 68.2871 349.769 69.3805 349.769 71.5672V75.9408L350.863 77.0342H361.793L362.886 78.1276V89.0576L361.793 90.151H350.863L349.769 91.2444V130.591L348.676 131.684H335.559L334.466 130.591V91.2444L333.372 90.151H325.723L324.629 89.0576V78.1276L325.723 77.0342H333.372L334.466 75.9408V71.5672C334.466 59.5438 343.209 55.1702 353.046 55.1702H362.882L363.976 56.2636H363.98Z"
            fill="#014847"
          />
          <path
            d="M404.42 132.774C400.046 143.704 395.677 150.261 380.373 150.261H374.906L373.813 149.167V138.237L374.906 137.144H380.373C385.836 137.144 386.929 136.05 388.023 132.77V131.677L370.536 89.05V78.1199L371.63 77.0265H381.466L382.56 78.1199L395.677 115.284H396.77L409.887 78.1199L410.98 77.0265H420.817L421.91 78.1199V89.05L404.424 132.77L404.42 132.774Z"
            fill="#014847"
          />
          <path
            d="M135.454 131.681L134.361 130.587L134.368 98.9172C134.368 93.4541 132.22 89.2182 125.625 89.0806C122.234 88.9926 118.354 89.0729 114.209 89.2488L113.59 89.8834L113.598 130.587L112.504 131.681H99.3913L98.2979 130.587V77.5388L99.3913 76.4454L128.901 76.1778C143.685 76.1778 149.668 86.3356 149.668 97.8009V130.587L148.575 131.681H135.454Z"
            fill="#014847"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'Northflank',
    onHome: true,
    description:
      'Northflank est un hébergeur qui vous permet de rendre vos sites Web et APIs accessibles au public.',
    svg: (
      <svg height="54" viewBox="0 0 53 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M35.209 17.099l-3.688.909-2.105-3.666-1.301-2.259-1.466-2.522-3.41-5.906h-5.514L3.934 27.547l2.76 4.766H8.8v3.666H5.64a1.833 1.833 0 01-1.58-.913L.245 28.467a1.833 1.833 0 010-1.833L15.096.913A1.833 1.833 0 0116.677 0h7.626a1.833 1.833 0 011.58.913l4.994 8.64.648 1.134 1.467 2.518.653 1.13 1.565 2.764z"
          fill="url(#LogoType_svg__paint0_linear)"
        ></path>
        <path
          d="M19.839 26.436l-4.99 8.641a1.834 1.834 0 01-1.58.917H8.8l-4.864-8.432 2.76 4.766h5.5l5.52-9.561 2.123 3.67z"
          fill="url(#LogoType_svg__paint1_linear)"
        ></path>
        <path
          d="M35.208 18.924l-3.813 6.6a1.833 1.833 0 01-1.58.916h-4.458l-1.466-2.523-.653-1.129h5.5l2.756-4.765-.524-.91h4.212a1.832 1.832 0 01.026 1.811z"
          fill="url(#LogoType_svg__paint2_linear)"
        ></path>
        <path
          d="M45.32 3.674h-5.521l-5.5 9.558-2.104-3.667 4.993-8.64a1.833 1.833 0 011.58-.913h4.447l2.105 3.662z"
          fill="url(#LogoType_svg__paint3_linear)"
        ></path>
        <path
          d="M51.767 9.366L36.919 35.084a1.833 1.833 0 01-1.58.916h-7.625a1.833 1.833 0 01-1.58-.916l-4.34-7.516-1.306-2.255-1.466-2.522-.653-1.129-1.58-2.738 3.688-.917 2.108 3.666.653 1.13.652 1.128 1.467 2.523.649 1.125 2.107 3.666.653 1.13h5.5L48.06 8.478l-2.757-4.766h-2.042L43.196.047h3.16a1.833 1.833 0 011.58.913l3.813 6.599a1.834 1.834 0 01.018 1.807z"
          fill="url(#LogoType_svg__paint4_linear)"
        ></path>
        <path
          d="M23.245 13.228l-2.757 4.766.528.916H16.8a1.833 1.833 0 010-1.833l3.813-6.599a1.833 1.833 0 011.584-.916h4.461l1.467 2.522.652 1.129-5.532.015z"
          fill="url(#LogoType_svg__paint5_linear)"
        ></path>
        <defs>
          <linearGradient
            id="LogoType_svg__paint0_linear"
            x1="-1.228"
            y1="25.93"
            x2="29.93"
            y2="7.941"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#668CFF"></stop>
            <stop offset="0.49" stopColor="#0AF"></stop>
            <stop offset="0.8" stopColor="#00BFB5"></stop>
          </linearGradient>
          <linearGradient
            id="LogoType_svg__paint1_linear"
            x1="6.986"
            y1="32.852"
            x2="19.403"
            y2="25.681"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.5" stopColor="#668CFF"></stop>
            <stop offset="1" stopColor="#0AF" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="LogoType_svg__paint2_linear"
            x1="24.657"
            y1="25.234"
            x2="36.092"
            y2="18.631"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0AF" stopOpacity="0"></stop>
            <stop offset="0.4" stopColor="#00BFB5"></stop>
          </linearGradient>
          <linearGradient
            id="LogoType_svg__paint3_linear"
            x1="31.92"
            y1="9.14"
            x2="44.337"
            y2="1.973"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00BFB5" stopOpacity="0"></stop>
            <stop offset="0.5" stopColor="#00CC7C"></stop>
          </linearGradient>
          <linearGradient
            id="LogoType_svg__paint4_linear"
            x1="22.087"
            y1="28.078"
            x2="53.241"
            y2="10.092"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#0AF"></stop>
            <stop offset="0.51" stopColor="#00BFB5"></stop>
            <stop offset="0.8" stopColor="#00CC7C"></stop>
          </linearGradient>
          <linearGradient
            id="LogoType_svg__paint5_linear"
            x1="15.917"
            y1="17.392"
            x2="27.355"
            y2="10.786"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.6" stopColor="#0AF"></stop>
            <stop offset="1" stopColor="#00BFB5" stopOpacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: 'Stripe',
    onHome: true,
    description:
      "Stripe est une solution qui permet d'accepter les paiements par carte de crédit. C'est une solution sûre et rapide, utilisée par de nombreuses startups.",
    svg: (
      <svg width="112" height="54" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M112 24.8932504c0-8.3740764-3.969938-14.98174598-11.557641-14.98174598-7.6197194 0-12.2299696 6.60766958-12.2299696 14.91632348 0 9.846082 5.4426565 14.8181898 13.2544696 14.8181898 3.809859 0 6.691266-.8832034 8.868328-2.1262303v-6.5422472c-2.177062 1.112182-4.674281 1.799118-7.843828 1.799118-3.1055159 0-5.8588598-1.112182-6.2110317-4.9721078h15.6556417c0-.4252461.064031-2.1262304.064031-2.9113zM96.1842804 21.785683c0-3.6963696 2.2090783-5.2337977 4.2260626-5.2337977 1.952953 0 4.033969 1.5374281 4.033969 5.2337977h-8.2600316zM76.6867257 9.91150442c-3.0275141 0-4.9737732 1.42718958-6.0550282 2.42001708l-.401609-1.9236033h-6.7964602v36.1761526l7.7232502-1.6443706.030893-8.7803183c1.112148.8066723 2.7494771 1.9546292 5.4680612 1.9546292 5.5298471 0 10.5654062-4.4677239 10.5654062-14.3029215-.030893-8.9974993-5.1282381-13.89958518-10.5345132-13.89958518zM74.8331456 31.2883219c-1.822687 0-2.9039421-.6515431-3.6453741-1.4582154l-.030893-11.510594c.803218-.89975 1.9153661-1.5202672 3.6762671-1.5202672 2.8112631 0 4.7575221 3.1646377 4.7575221 7.2290254 0 4.1574652-1.915366 7.2600512-4.7575221 7.2600512zM52.5309735 7.92920354l7.9292035-1.66605833V0l-7.9292035 1.6352054zM52.5309735 10.9026549h7.92920354v26.7610619H52.5309735zM44.9802092 12.5551613l-.5045857-2.3196418h-6.8119067v27.4281973h7.8841513V19.0752357c1.8606597-2.4136814 5.0143202-1.9748302 5.9919549-1.6300186v-7.2096976c-1.0091714-.37615813-4.6989541-1.06578138-6.5596138 2.3196418zM28.647445 3.96460177L20.8461319 5.6361636l-.0319726 25.7484812c0 4.7575221 3.548958 8.2613729 8.2809021 8.2613729 2.6217528 0 4.5401085-.4821813 5.5952041-1.0607989v-6.5255202c-1.0231231.4178905-6.074793 1.8965798-6.074793-2.8609423v-11.411624h6.074793v-6.8469744h-6.074793l.0319725-6.97555613zM7.8979862 18.7665078c0-1.2743363.99895478-1.7644656 2.6534736-1.7644656 2.3725176 0 5.369382.7515317 7.7418995 2.0912185v-7.678693c-2.5910389-1.0782845-5.1508605-1.50306328-7.7418995-1.50306328C4.21434046 9.91150442 0 13.3750851 0 19.1586113c0 9.0183799 11.862588 7.5806671 11.862588 11.4690265 0 1.5030634-1.2486935 1.9931927-2.99686436 1.9931927-2.59103895 0-5.90007665-1.1109598-8.52233294-2.6140231v7.7767188c2.90321232 1.3070116 5.83764198 1.8624915 8.52233294 1.8624915 6.49320606 0 10.95728516-3.3655548 10.95728516-9.2144316-.0312173-9.7372362-11.9250226-8.0054459-11.9250226-11.6650783z"
          fill="#6772E5"
          fillRule="evenodd"
          transform="translate(0 5)"
        />
      </svg>
    ),
  },
  {
    name: 'Cloudinary',
    onHome: true,
    description:
      "Cloudinary est un service Cloud qui offre une solution d'hébergement CDN (Content Delivery Network) capable d'héberger des fichiers statiques tels que des images, des vidéos, des documents PDF ou encore des feuilles de style ou des scripts JavaScript.",
    svg: (
      <svg width="80" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd" css={{ transform: 'scale(1.3) translate(0px, 1px)' }}>
          <path
            d="M52.3967903 36.3619664c-.7301344 0-1.4098991-.4646723-1.6494958-1.1966219-.2981344-.9111932.1987563-1.8918151 1.1104034-2.1899495 3.3026218-1.0809076 5.4363025-3.9755799 5.4363025-7.3748572 0-4.3050252-3.5022857-7.8077647-7.8073109-7.8077647-.299042 0-.6207731.0235966-1.0123866.0744202l-1.6975966.220084-.2436807-1.6948739C45.4897819 9.12463866 39.1586223 3.64386555 31.8060004 3.64386555c-6.0784033 0-11.4897479 3.63887395-13.784521 9.27075625l-.432 1.0595799-1.1435294.0208739c-5.25524371.0966555-9.53077312 4.448874-9.53077312 9.701395 0 3.8344538 2.2262521 7.3312941 5.67136135 8.9081849.87171427.3993277 1.25515967 1.4294117.85583197 2.301126-.39932777.8717143-1.42895802 1.2542521-2.30067231.8562857-4.67667227-2.1409411-7.69885714-6.876605-7.69885714-12.0655966 0-6.7522689 5.20260504-12.4086555 11.81102525-13.103395C18.2987399 4.22652101 24.6802693.1719832 31.8064542.1719832c8.5292773 0 15.9436134 5.97993277 17.8662857 14.1507227 6.1346723.0993781 11.094958 5.1204706 11.094958 11.2782857 0 4.8522857-3.146521 9.1418823-7.8290924 10.6743025-.1806051.0589916-.3625715.0866723-.5418152.0866723z"
            fill="#3442CD"
          />
          <path
            d="M25.8664542 37.1692437c-.0004538-.0004538-.0004538-.0004538-.0009076-.0004538s-.0009075-.0004538-.0013613-.0004538h-.0004538l-.0004538-.0004537-.0004538-.0004538s-.0004537 0-.0004537-.0004538h-.0004538l-.0004538-.0004538c.0004538-.0004538-.0004538-.0004538-.0004538-.0004538l-.0004538-.0004538h-.0004537l-.0004538-.0004537c.0004538.0004537-.0004538-.0004538-.0004538-.0004538s-.0009076-.0004538-.0013614-.0004538l-.0004537-.0004538h-.0004538l-.0004538-.0004538-.0004538-.0004537c-.0013613-.0004538-.0009075-.0004538-.0013613-.0004538-.0004538.0004538-.0004538-.0004538-.0009076-.0004538l-.0004538-.0004538s-.0004538-.0004538-.0009075-.0004538l-.0004538-.0004538c-.0004538-.0004537-.0013614-.0004537-.0018151-.0004537-.0004538 0-.0013614-.0004538-.0018152-.0004538-.0004537-.0004538-.0004537-.0004538-.0009075-.0004538h-.0004538c-.0004538-.0004538-.0009076-.0004538-.0013614-.0004538-.0004537-.0004538-.0013613-.0004538-.0013613-.0004538h-.0004538l-.0009075-.0004537c-.0004538 0-.0004538-.0004538-.0004538-.0004538H25.84195c-.0267731-.0095294-.0553614-.0154286-.0853109-.0167899h-.0027227-.0004538-.0009076l-.0004537-.0004538h-.0054454.0009075-.0027227c-.7514621 0-1.3663361-.6116975-1.3708739-1.3613446V20.5018487h1.1707563c.1783361.0077143.2999496-.1293277.2999496-.2940504 0-.1229748-.0753278-.2282521-.1824202-.2722689l-5.6173613-3.8771092c-.1007395-.0694286-.2336975-.0694286-.334437 0l-5.6613782 3.9075126c-.1061848.0730588-.1520168.2069243-.1138991.3298991.0385714.1229748.1520168.2064706.2808907.2064706h1.1707563l.0009076 15.2806387c.0058992 1.0564033.8544706 1.9185882 1.9340168 1.9458151.0122521.0013613.0240504.0022689.0363025.0022689H25.7493786c.0771428-.0013613.1470252-.0322185.1987563-.0816807l.0004537-.0004537.002269-.002269c.0004537-.0004537.0009075-.0004537.0013613-.0013613l.0004538-.0004538.0004538-.0004538.0004537-.0004537.0004538-.0004538.0004538-.0004538.0004538-.0004538c.0009076-.0004538.0004538-.0004538.0009076-.0009075l.0004537-.0004538.0004538-.0004538.0004538-.0004538c.0508235-.0526386.0825882-.1238823.083042-.2028403v-.0013614.0009076-.0027227c-.0022689-.1175294-.072605-.2191765-.1737983-.2650084z"
            fill="#3442CD"
          />
          <path
            d="M38.0137315 37.1692437s-.0004538-.0004538-.0009076-.0004538c-.0004537 0-.0009075-.0004538-.0013613-.0004538h-.0004538l-.0004538-.0004537-.0004537-.0004538h-.0004538l-.0004538-.0004538-.0004538-.0004538c.0004538-.0004538-.0004538-.0004538-.0009076-.0004538l-.0004537-.0004538h-.0004538c-.0004538 0-.0004538-.0004537-.0004538-.0004537-.0009076.0004537-.0009076-.0004538-.0009076-.0004538l-.0009075-.0004538-.0004538-.0004538h-.0004538l-.0004538-.0004538-.0004538-.0004537c-.0004537-.0004538-.0009075-.0004538-.0009075-.0004538-.0004538.0004538-.0004538-.0004538-.0013614-.0004538l-.0004537-.0004538-.0004538-.0004538s-.0004538 0-.0009076-.0004538c-.0004538-.0004537-.0013613-.0004537-.0018151-.0004537-.0004538-.0004538-.0013614-.0004538-.0018151-.0004538-.0004538-.0004538-.0004538-.0004538-.0009076-.0004538s-.0004538 0-.0009076-.0004538c0 0-.0004537 0-.0009075-.0004538-.0013614-.0004537-.0004538-.0004537-.0009076-.0004537-.0013613 0-.0004538 0-.0009076-.0004538 0 0-.0004537-.0004538-.0009075-.0004538l-.0004538-.0004538h.0013613c-.0267731-.0095294-.0553613-.0154286-.0853109-.0167899h-.0022689H37.9016475l-.0004538-.0004538h-.004084-.0013614-.0036302c-.7510084 0-1.3658824-.6116975-1.3704202-1.3613445v-11.855042h1.1703025c.004084-.0004538.0072605-.0004538.0117983 0 .1624538 0 .2940505-.1315967.2940505-.2940505 0-.1229747-.0753278-.2282521-.1824202-.2722689l-5.6178151-3.8771092c-.1002858-.0694286-.2336975-.0694286-.334437 0l-5.6613782 3.9075126c-.1061848.0730588-.1520168.2069244-.1138991.3298992.0385714.1229747.1520168.2064705.2808907.2064705h1.165311l.0009075 11.8595799c.0049916 1.0568571.8549244 1.9194958 1.9349244 1.9462689.0117983.0013613.0235966.0018151.0353949.0018151H37.8966559c.0771428-.0013613.1470252-.0322185.1987563-.0816807l.0004538-.0004537c.0009075-.0009076.0027226-.0018152.0022689-.002269.0004537-.0004537.0009075-.0004537.0013613-.0013613l.0004538-.0004538.0004538-.0004538.0004538-.0004537s.0004537 0 .0004537-.0004538l.0004538-.0004538c.0004538 0 .0004538-.0004538.0004538-.0004538.0013613-.0004538.0009076-.0004538.0009076-.0009075l.0004537-.0004538.0004538-.0004538.0004538-.0004538c.0508235-.0526386.0825882-.1238823.083042-.2028403v-.0013614.0009076-.0027227c-.0022689-.1175294-.072605-.2191765-.1737983-.2650084z"
            fill="#3442CD"
          />
          <path
            d="M50.1650928 37.1692437l-.0009075-.0004538c-.0004538 0-.0009076-.0004538-.0013614-.0004538h-.0004537l-.0004538-.0004537-.0004538-.0004538c-.0004538 0-.0004538 0-.0004538-.0004538h-.0004538l-.0004537-.0004538-.0004538-.0004538s-.0004538 0-.0004538-.0004538h-.0004538l-.0004538-.0004537c-.0004538.0004537-.0004538-.0004538-.0009075-.0004538.0004537-.0004538-.0004538-.0004538-.0009076-.0004538l-.0004538-.0004538h-.0004538l-.0004537-.0004538-.0004538-.0004537c-.0013614-.0004538-.0009076-.0004538-.0009076-.0004538-.0004538.0004538-.0004538-.0004538-.0013613-.0004538l-.0004538-.0004538c.0004538-.0004538-.0004538-.0004538-.0009076-.0004538 0 0-.0004538 0-.0004538-.0004538-.0004537-.0004537-.0013613-.0004537-.0018151-.0004537-.0004538 0-.0013613-.0004538-.0018151-.0004538l-.0009076-.0004538s-.0004538 0-.0009075-.0004538l-.0009076-.0004538c-.0013613-.0004537-.0013613-.0004537-.0009076-.0004537-.0013613 0-.0013613 0-.0009075-.0004538-.0004538 0-.0004538-.0004538-.0004538-.0004538-.0004538 0-.0009076-.0004538-.0009076-.0004538h-.0004538c-.0267731-.0095294-.0553613-.0154286-.0853109-.0167899h-.004084c-.0004538-.0004538-.0004538-.0004538-.0009076-.0004538h-.0009075-.0013614-.0027227-.0004538H50.0439332h-.0022689-.0004538c-.7510084 0-1.3658824-.6116975-1.3704202-1.3613445V27.342605h1.173479c.1656303-.004084.2999496-.1293277.2999496-.2940504 0-.1229748-.0753277-.2282521-.1824202-.2722689l-5.6178151-3.8771092c-.1002857-.0694286-.2336975-.0694286-.334437 0l-5.6613781 3.9070588c-.1061849.0730588-.1520168.2069244-.1138992.3298992.0385714.1229747.1520168.2064705.2808908.2064705h1.1675798l.0009076 8.4398824c.0058991 1.0568571.8553781 1.9199496 1.9349243 1.9462689.0117984.0013613.0235967.0018151.035395.0018151h8.3913277c.0771429-.0013613.1470252-.0322185.1987563-.0816806l.0004538-.0004538c.0009076-.0009076.0022689-.0018152.0022689-.0022689.0004538-.0004538.0009076-.0004538.0013614-.0013614l.0004537-.0004538.0004538-.0004537.0004538-.0004538.0004538-.0004538.0004538-.0004538.0004538-.0004538c.0013613-.0004537.0004537-.0004537.0009075-.0009075l.0004538-.0004538.0004538-.0004538.0004538-.0004538c.0508235-.0526386.0825882-.1238823.083042-.2028403v-.0013614.0013614-.0027227c0-.1175294-.0703362-.2191765-.1710757-.2650084z"
            fill="#3442CD"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'Forest Admin',
    onHome: false,
    description:
      "Forest Admin est une plateforme qui permet de créer facilement des interfaces d'administration pour les applications Web et Mobile, en se connectant directement aux bases de données.",
    svg: (
      <svg
        width="57"
        height="57"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="4" fill="#54BD7E" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.4424 15.8656C31.2303 15.4295 34.7289 12.6733 35.819 9C28.1808 12.5194 18.6498 8.21391 16.8459 15.9903L15.9212 20.1359C17.5299 17.64 19.6548 16.3017 25.4424 15.8656ZM22.4329 16.5715C19.5883 16.9813 17.3065 18.3009 16.0259 20.6187C15.6137 21.3645 15.4689 22.166 15.4689 22.166L14.8143 25.1003C15.6343 23.638 17.1007 21.7693 20.9438 20.8801C21.0303 20.4148 21.5551 17.7476 22.4329 16.5715ZM14.217 27.7777L13.2173 32.2598C15.8661 27.2163 21.5665 26.2374 22.2704 26.0903C27.2343 25.0522 29.6242 22.5875 30.5746 19.3846C26.2433 21.8339 16.1334 18.7584 14.217 27.7777ZM12.7358 34.4193L12 37.718C17.8704 37.3875 18.5178 31.746 19.4757 27.2644C17.6493 27.9019 13.6243 30.4001 12.7358 34.4193Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    name: 'Terminal',
    onHome: false,
    description:
      "Le terminal est un environnement en ligne de commande permettant d'exécuter des commandes système, de compiler et d'exécuter du code JavaScript sur un ordinateur, sans avoir à recourir à une interface graphique.",
    svg: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="57"
        height="57"
        viewBox="0 0 512 512"
      >
        <title></title>
        <g id="icomoon-ignore"></g>
        <path
          fill="#000"
          d="M0 32v448h512v-448h-512zM480 448h-448v-384h448v384zM448 96h-384v320h384v-320zM224 256h-32v32h-32v32h-32v-32h32v-32h32v-32h-32v-32h-32v-32h32v32h32v32h32v32zM352 320h-96v-32h96v32z"
        ></path>
      </svg>
    ),
  },
  {
    name: 'Retool',
    onHome: false,
    description:
      "Retool est une plateforme qui permet de créer facilement des interfaces d'administration pour les applications Web et Mobile, en se connectant directement aux bases de données.",
    svg: (
      <svg
        width="112"
        height="54"
        viewBox="0 -7 112 24"
        fill="hsl(0, 0%, 15%)"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Retool Logo"
        className="retool-logo"
      >
        <path
          d="M0 2.19906C0 0.984555 0.984555 0 2.19907 0H10.8009C12.0154 0 13 0.984555 13 2.19907V3.90047C13 4.50772 12.5077 5 11.9005 5H1.09953C0.492278 5 0 4.50772 0 3.90047V2.19906Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M0 9.09953C0 8.49228 0.492278 8 1.09953 8H21.8009C23.0154 8 24 8.98456 24 10.1991V15.9005C24 16.5077 23.5077 17 22.9005 17H2.19907C0.984556 17 0 16.0154 0 14.8009V9.09953Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M11 21.0995C11 20.4923 11.4923 20 12.0995 20H22.9005C23.5077 20 24 20.4923 24 21.0995V21.8009C24 23.0154 23.0154 24 21.8009 24H13.1991C11.9846 24 11 23.0154 11 21.8009V21.0995Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M37.5956 14.741H39.9071L44.1999 21.7581H49.4559L44.6953 14.2456C47.337 13.3375 48.878 11.3012 48.878 8.35672C48.878 4.22898 45.9886 2 41.338 2H33V21.7581H37.5956V14.741ZM37.5956 10.9985V5.88008H41.0904C43.2643 5.88008 44.365 6.8157 44.365 8.43928C44.365 10.0353 43.2643 10.9985 41.0904 10.9985H37.5956Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M57.3631 22.0608C60.2525 22.0608 62.8943 20.6024 63.9675 17.823L60.2801 16.6397C59.8673 17.9056 58.7941 18.566 57.4182 18.566C55.7395 18.566 54.5563 17.4378 54.2536 15.4564H64.0776V14.3007C64.0776 10.2004 61.6835 6.95329 57.2806 6.95329C53.0978 6.95329 50.0157 10.2004 50.0157 14.4933C50.0157 19.0063 52.9877 22.0608 57.3631 22.0608ZM57.2255 10.3656C58.8491 10.3656 59.7022 11.4663 59.7297 12.7596H54.3912C54.8314 11.1636 55.8771 10.3656 57.2255 10.3656Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M66.5732 17.878C66.5732 20.85 68.1417 21.8957 71.2788 21.8957C72.3245 21.8957 73.15 21.8132 73.9205 21.7031V18.0982C73.4252 18.1532 73.1775 18.1807 72.6547 18.1807C71.554 18.1807 70.921 17.9606 70.921 16.7498V10.8884H73.7554V7.25599H70.921V3.23832H66.5732V7.25599H64.7294V10.8884H66.5732V17.878Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M89.6719 14.5208C89.6719 10.0078 86.6725 6.95329 82.4071 6.95329C78.1143 6.95329 75.1423 10.0078 75.1423 14.5208C75.1423 19.0338 78.1143 22.0608 82.4071 22.0608C86.6725 22.0608 89.6719 19.0338 89.6719 14.5208ZM79.5177 14.5208C79.5177 11.9891 80.646 10.5582 82.4071 10.5582C84.1683 10.5582 85.2965 11.9891 85.2965 14.5208C85.2965 17.0525 84.1683 18.4834 82.4071 18.4834C80.646 18.4834 79.5177 17.0525 79.5177 14.5208Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path
          d="M105.527 14.5208C105.527 10.0078 102.528 6.95329 98.2624 6.95329C93.9695 6.95329 90.9975 10.0078 90.9975 14.5208C90.9975 19.0338 93.9695 22.0608 98.2624 22.0608C102.528 22.0608 105.527 19.0338 105.527 14.5208ZM95.373 14.5208C95.373 11.9891 96.5012 10.5582 98.2624 10.5582C100.024 10.5582 101.152 11.9891 101.152 14.5208C101.152 17.0525 100.024 18.4834 98.2624 18.4834C96.5012 18.4834 95.373 17.0525 95.373 14.5208Z"
          fill="hsl(0, 0%, 15%)"
        ></path>
        <path d="M112 2H107.597V21.7581H112V2Z" fill="hsl(0, 0%, 15%)"></path>
      </svg>
    ),
  },
  {
    name: 'Strapi',
    onHome: true,
    description:
      'Strapi est un outil qui facilite la création de sites Web en fournissant une interface simple pour gérer le contenu. Il utilise Node.js et permet de construire rapidement des applications Web sans avoir besoin de compétences avancées en programmation.',
    svg: (
      <svg
        width="57"
        height="57"
        viewBox="0 0 600 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 208C0 109.948 0 60.9218 30.4609 30.4609C60.9218 0 109.948 0 208 0H392C490.052 0 539.078 0 569.539 30.4609C600 60.9218 600 109.948 600 208V392C600 490.052 600 539.078 569.539 569.539C539.078 600 490.052 600 392 600H208C109.948 600 60.9218 600 30.4609 569.539C0 539.078 0 490.052 0 392V208Z"
          fill="#4945FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M414 182H212V285H315V388H418V186C418 183.791 416.209 182 414 182Z"
          fill="white"
        />
        <rect x="311" y="285" width="4" height="4" fill="white" />
        <path
          d="M212 285H311C313.209 285 315 286.791 315 289V388H216C213.791 388 212 386.209 212 384V285Z"
          fill="#9593FF"
        />
        <path
          d="M315 388H418L318.414 487.586C317.154 488.846 315 487.953 315 486.172V388Z"
          fill="#9593FF"
        />
        <path
          d="M212 285H113.828C112.046 285 111.154 282.846 112.414 281.586L212 182V285Z"
          fill="#9593FF"
        />
      </svg>
    ),
  },
  {
    name: 'SQLite',
    onHome: false,
    description:
      'SQLite est une bibliothèque de base de données légère et autonome, idéale pour stocker des données dans des applications sans nécessiter de serveur externe. Elle offre un accès simple via SQL standard, parfait pour les applications mobiles et les petits projets.',
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 6.554 6.555"
        preserveAspectRatio="xMidYMid"
      >
        <defs>
          <linearGradient
            x1="2.983"
            y1=".53"
            x2="2.983"
            y2="4.744"
            id="A"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#97d9f6" offset="0%" />
            <stop stopColor="#0f80cc" offset="92.024%" />
            <stop stopColor="#0f80cc" offset="100%" />
          </linearGradient>
        </defs>
        <path
          d="M4.96.29H.847c-.276 0-.5.226-.5.5v4.536c0 .276.226.5.5.5h2.71c-.03-1.348.43-3.964 1.404-5.54z"
          fill="#0f80cc"
        />
        <path
          d="M4.81.437H.847c-.196 0-.355.16-.355.355v4.205c.898-.345 2.245-.642 3.177-.628A28.93 28.93 0 0 1 4.811.437z"
          fill="url(#A)"
        />
        <path
          d="M5.92.142c-.282-.25-.623-.15-.96.148l-.15.146c-.576.61-1.1 1.742-1.276 2.607a2.38 2.38 0 0 1 .148.426l.022.1.022.102s-.005-.02-.026-.08l-.014-.04a.461.461 0 0 0-.009-.022c-.038-.087-.14-.272-.187-.352a8.789 8.789 0 0 0-.103.321c.132.242.212.656.212.656s-.007-.027-.04-.12c-.03-.083-.176-.34-.21-.4-.06.22-.083.368-.062.404.04.07.08.2.115.324a7.52 7.52 0 0 1 .132.666l.005.062a6.11 6.11 0 0 0 .015.75c.026.313.075.582.137.726l.042-.023c-.09-.284-.128-.655-.112-1.084.025-.655.175-1.445.454-2.268C4.548 1.938 5.2.94 5.798.464c-.545.492-1.282 2.084-1.502 2.673-.247.66-.422 1.28-.528 1.873.182-.556.77-.796.77-.796s.29-.356.626-.865l-.645.172-.208.092s.53-.323.987-.47c.627-.987 1.31-2.39.622-3.002"
          fill="#003b57"
        />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    onHome: false,
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" height="57" viewBox="0 0 72 72" width="57">
        <g fill="none" fillRule="evenodd">
          <path
            d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
            fill="#007EBB"
          />
          <path
            d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z"
            fill="#FFF"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'CV',
    onHome: false,
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 480 480"
        height="57"
        width="57"
      >
        <g>
          <g>
            <path
              d="M413.648,74.336L341.664,2.352C340.216,0.896,338.216,0,336,0H104C81.944,0,64,17.944,64,40v344c0,22.056,17.944,40,40,40
			h88v56h16v-56h120c4.416,0,8-3.576,8-8v-40c0-14.88,10.216-27.432,24-30.984V416v64h16v-56c22.056,0,40-17.944,40-40V80
			C416,77.784,415.104,75.784,413.648,74.336z M344,27.312L388.688,72H344V27.312z M400,384c0,13.232-10.768,24-24,24v-72
			c0-4.424-3.584-8-8-8c-26.472,0-48,21.528-48,48v32H104c-13.232,0-24-10.768-24-24V40c0-13.232,10.768-24,24-24h224v64
			c0,4.424,3.584,8,8,8h64V384z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M224,48H112c-4.416,0-8,3.576-8,8v112c0,4.424,3.584,8,8,8h32h48h32c4.416,0,8-3.576,8-8V56C232,51.576,228.416,48,224,48
			z M184,160h-32v-16c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16V160z M160,104c0-4.416,3.592-8,8-8s8,3.584,8,8s-3.592,8-8,8
			S160,108.416,160,104z M216,160h-16v-16c0-10.488-5.136-19.72-12.952-25.56c3.064-4.032,4.952-9,4.952-14.44
			c0-13.232-10.768-24-24-24s-24,10.768-24,24c0,5.44,1.888,10.408,4.952,14.44C141.136,124.28,136,133.512,136,144v16h-16V64h96
			V160z"
            />
          </g>
        </g>
        <g>
          <g>
            <rect x="248" y="72" width="40" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="248" y="104" width="48" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="312" y="104" width="40" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="248" y="136" width="104" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="144" y="200" width="64" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="224" y="200" width="48" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="288" y="200" width="80" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="112" y="232" width="64" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="192" y="232" width="128" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="336" y="232" width="32" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="112" y="264" width="32" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="160" y="264" width="96" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="272" y="264" width="96" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="112" y="296" width="32" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="160" y="296" width="96" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="272" y="296" width="96" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="112" y="328" width="72" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="200" y="328" width="112" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="112" y="360" width="32" height="16" />
          </g>
        </g>
        <g>
          <g>
            <rect x="160" y="360" width="136" height="16" />
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: 'Entretien',
    onHome: false,
    svg: (
      <svg
        height="57"
        width="57"
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <style type="text/css"></style>
        <g>
          <path
            className="st0"
            d="M482.518,478.896L455.62,334.288c-2.993-14.356-15.644-24.65-30.3-24.65H86.695
		c-14.67,0-27.322,10.294-30.308,24.65L29.483,478.896c-1.682,8.101,0.376,16.533,5.602,22.96C40.311,508.275,48.153,512,56.427,512
		h170.805c0-3.748,0-8.251,0-13.908c-5.61-6.254-9.885-18.937-12.423-33.333c-5.924-2.114-9.311-5.493-13.531-20.304
		c-4.33-15.142,5.854-15.252,6.687-15.237c-1.43-9.68-3.387-28.822,1.682-38.424c0,0-3.473-6.224-3.473-14.546
		c14.552,2.082,60.968-27.706,74.822-3.458c20.084-2.074,32.075,26.269,22.96,56.427c0,0,11.276-0.534,6.766,15.237
		c-4.22,14.812-7.606,18.19-13.523,20.304c-2.547,14.396-6.806,27.078-12.432,33.333c0,5.658,0,10.16,0,13.908h170.814
		c8.282,0,16.109-3.725,21.334-10.144C482.14,495.428,484.199,486.996,482.518,478.896z"
          />
          <path
            className="st0"
            d="M301.638,155.671c0,4.935,2.059,8.628,2.059,8.628c-3.017,5.705-1.838,17.052-1.006,22.796
		c-0.48-0.008-6.53,0.056-3.952,9.044c2.498,8.785,4.495,10.796,8.022,12.046c1.502,8.542,4.032,16.062,7.371,19.778
		c0,4.448,0,7.701,0,10.294c0,0.259-0.039,0.534-0.126,0.826l11.355,5.461v8.769h11.684v-8.777l11.339-5.453
		c-0.079-0.291-0.126-0.566-0.126-0.826c0-2.592,0-5.846,0-10.294c3.339-3.717,5.885-11.237,7.37-19.778
		c3.512-1.25,5.539-3.261,8.038-12.046c2.672-9.366-4.015-9.044-4.015-9.044c5.414-17.892-1.713-34.708-13.626-33.474
		C337.816,139.241,310.274,156.897,301.638,155.671z"
          />
          <path
            className="st0"
            d="M338.531,278.426l-1.486-18.882h-11.684l-1.494,18.882l-19.024-29.278c-8.636,0-32.625,21.295-34.024,47.03
		h120.775c-1.406-25.735-25.389-47.03-34.032-47.03L338.531,278.426z"
          />
          <path
            className="st0"
            d="M156.354,208.185c1.502,8.542,4.048,16.062,7.372,19.778c0,4.448,0,7.701,0,10.294
		c0,0.259-0.048,0.534-0.126,0.826l11.355,5.453v8.777h11.684v-8.777l11.331-5.453c-0.062-0.291-0.117-0.566-0.117-0.826
		c0-2.592,0-5.846,0-10.294c3.347-3.717,5.87-11.237,7.378-19.778c3.512-1.25,5.532-3.261,8.03-12.046c2.688-9.366-4-9.044-4-9.044
		c5.398-17.892-1.728-34.708-13.648-33.474c-8.204-14.38-35.745,3.277-44.365,2.05c0,4.935,2.051,8.628,2.051,8.628
		c-3.01,5.705-1.846,17.052-0.998,22.796c-0.495-0.008-6.545,0.056-3.968,9.044C150.831,204.924,152.842,206.935,156.354,208.185z"
          />
          <path
            className="st0"
            d="M207.156,249.148l-19.023,29.278l-1.494-18.882h-11.684l-1.486,18.882l-19.031-29.278
		c-8.636,0-32.626,21.295-34.025,47.03H241.18C239.766,270.442,215.807,249.148,207.156,249.148z"
          />
          <path
            className="st0"
            d="M212.704,118.189l-12.227,30.543l8.824-1.092c30.497-3.811,59.696-15.228,73.565-21.224
		c13.178-4.699,24.54-12.746,32.736-23.181c8.235-10.514,13.24-23.581,13.232-37.702c0.008-9.24-2.13-18.065-5.925-25.978
		c-5.697-11.889-15.056-21.75-26.63-28.665C284.696,3.992,270.859,0.015,255.992,0c-19.778,0.015-37.796,7.072-51.045,18.756
		c-6.624,5.847-12.062,12.871-15.841,20.8c-3.796,7.913-5.933,16.738-5.933,25.978c0,11.771,3.481,22.85,9.429,32.288
		C197.694,105.892,204.578,112.791,212.704,118.189z M198.064,44.907c4.59-9.602,12.408-18.002,22.45-23.99
		c10.05-5.996,22.276-9.555,35.478-9.555c17.633,0,33.49,6.333,44.766,16.297c5.634,4.982,10.129,10.843,13.178,17.248
		c3.065,6.412,4.73,13.334,4.73,20.627c0,11.103-3.858,21.436-10.726,30.222c-6.851,8.761-16.737,15.841-28.445,19.958l-0.158,0.047
		l-0.157,0.071c-11.999,5.209-36.272,14.67-62.069,19.157l8.746-21.813l-4.298-2.46c-8.66-4.95-15.755-11.692-20.635-19.432
		c-4.887-7.756-7.575-16.47-7.583-25.75C193.342,58.242,195,51.319,198.064,44.907z"
          />
          <path
            className="st0"
            d="M227.28,75.962c4.361,0,7.913-3.952,7.913-8.833c0-4.864-3.552-8.824-7.913-8.824
		c-4.369,0-7.905,3.96-7.905,8.824C219.375,72.009,222.91,75.962,227.28,75.962z"
          />
          <path
            className="st0"
            d="M257.784,75.962c4.369,0,7.913-3.952,7.913-8.833c0-4.864-3.544-8.824-7.913-8.824
		c-4.369,0-7.913,3.96-7.913,8.824C249.871,72.009,253.414,75.962,257.784,75.962z"
          />
          <path
            className="st0"
            d="M288.288,75.962c4.369,0,7.913-3.952,7.913-8.833c0-4.864-3.544-8.824-7.913-8.824
		c-4.368,0-7.913,3.96-7.913,8.824C280.375,72.009,283.919,75.962,288.288,75.962z"
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'Prisma',
    onHome: true,
    description:
      "Prisma est un ORM moderne pour Node.js et TypeScript, facilitant l'accès aux bases de données avec une syntaxe type-safe.",
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-27 0 310 310"
        height="70"
        width="70"
      >
        <g>
          <path
            d="M254.312882,235.518775 L148.000961,9.74987264 C145.309805,4.08935083 139.731924,0.359884549 133.472618,0.0359753113 C127.198908,-0.384374336 121.212054,2.71925839 117.939655,8.08838662 L2.63252565,194.847143 C-0.947129465,200.604248 -0.871814894,207.912774 2.8257217,213.594888 L59.2003287,300.896318 C63.5805009,307.626626 71.8662281,310.673635 79.5631922,308.384597 L243.161606,259.992851 C248.145475,258.535702 252.252801,254.989363 254.421072,250.271225 C256.559881,245.57581 256.523135,240.176915 254.32061,235.511047 L254.312882,235.518775 Z M230.511129,245.201761 L91.6881763,286.252058 C87.4533189,287.511696 83.388474,283.840971 84.269448,279.567474 L133.866738,42.0831633 C134.794079,37.6396542 140.929985,36.9364206 142.869673,41.0476325 L234.684164,236.021085 C235.505704,237.779423 235.515611,239.809427 234.711272,241.575701 C233.906934,243.341974 232.369115,244.667163 230.503401,245.201761 L230.511129,245.201761 Z"
            fill="#000000"
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    name: 'Docker',
    onHome: true,
    description:
      'Docker est un outil de virtualisation de conteneurs, permettant de créer des environnements isolés pour les applications.',
    svg: (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 756.26 596.9"
        height="70"
        width="70"
        fill="#1d63ed"
      >
        <path
          class="cls-1"
          d="M743.96,245.25c-18.54-12.48-67.26-17.81-102.68-8.27-1.91-35.28-20.1-65.01-53.38-90.95l-12.32-8.27-8.21,12.4c-16.14,24.5-22.94,57.14-20.53,86.81,1.9,18.28,8.26,38.83,20.53,53.74-46.1,26.74-88.59,20.67-276.77,20.67H.06c-.85,42.49,5.98,124.23,57.96,190.77,5.74,7.35,12.04,14.46,18.87,21.31,42.26,42.32,106.11,73.35,201.59,73.44,145.66.13,270.46-78.6,346.37-268.97,24.98.41,90.92,4.48,123.19-57.88.79-1.05,8.21-16.54,8.21-16.54l-12.3-8.27ZM189.67,206.39h-81.7v81.7h81.7v-81.7ZM295.22,206.39h-81.7v81.7h81.7v-81.7ZM400.77,206.39h-81.7v81.7h81.7v-81.7ZM506.32,206.39h-81.7v81.7h81.7v-81.7ZM84.12,206.39H2.42v81.7h81.7v-81.7ZM189.67,103.2h-81.7v81.7h81.7v-81.7ZM295.22,103.2h-81.7v81.7h81.7v-81.7ZM400.77,103.2h-81.7v81.7h81.7v-81.7ZM400.77,0h-81.7v81.7h81.7V0Z"
        />
      </svg>
    ),
  },
  {
    name: 'Cursor',
    onHome: true,
    description:
      'Cursor est un éditeur de code basé sur VS Code, intégrant une intelligence artificielle pour accélérer le développement.',
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        height="70"
        width="70"
      >
        <path
          d="M11.925 24l10.425-6-10.425-6L1.5 18l10.425 6z"
          fill="url(#lobe-icons-cursorundefined-fill-0)"
        ></path>
        <path
          d="M22.35 18V6L11.925 0v12l10.425 6z"
          fill="url(#lobe-icons-cursorundefined-fill-1)"
        ></path>
        <path
          d="M11.925 0L1.5 6v12l10.425-6V0z"
          fill="url(#lobe-icons-cursorundefined-fill-2)"
        ></path>
        <path d="M22.35 6L11.925 24V12L22.35 6z" fill="#555"></path>
        <path d="M22.35 6l-10.425 6L1.5 6h20.85z" fill="#000"></path>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="lobe-icons-cursorundefined-fill-0"
            x1="11.925"
            x2="11.925"
            y1="12"
            y2="24"
          >
            <stop offset=".16" stop-color="#000" stop-opacity=".39"></stop>
            <stop offset=".658" stop-color="#000" stop-opacity=".8"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="lobe-icons-cursorundefined-fill-1"
            x1="22.35"
            x2="11.925"
            y1="6.037"
            y2="12.15"
          >
            <stop offset=".182" stop-color="#000" stop-opacity=".31"></stop>
            <stop offset=".715" stop-color="#000" stop-opacity="0"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="lobe-icons-cursorundefined-fill-2"
            x1="11.925"
            x2="1.5"
            y1="0"
            y2="18"
          >
            <stop stop-color="#000" stop-opacity=".6"></stop>
            <stop offset=".667" stop-color="#000" stop-opacity=".22"></stop>
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: 'ChatGPT',
    onHome: true,
    description:
      'ChatGPT est un assistant conversationnel intelligent développé par OpenAI, capable de comprendre et générer du langage naturel.',
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 320"
        height="70"
        width="70"
      >
        <path d="m297.06 130.97c7.26-21.79 4.76-45.66-6.85-65.48-17.46-30.4-52.56-46.04-86.84-38.68-15.25-17.18-37.16-26.95-60.13-26.81-35.04-.08-66.13 22.48-76.91 55.82-22.51 4.61-41.94 18.7-53.31 38.67-17.59 30.32-13.58 68.54 9.92 94.54-7.26 21.79-4.76 45.66 6.85 65.48 17.46 30.4 52.56 46.04 86.84 38.68 15.24 17.18 37.16 26.95 60.13 26.8 35.06.09 66.16-22.49 76.94-55.86 22.51-4.61 41.94-18.7 53.31-38.67 17.57-30.32 13.55-68.51-9.94-94.51zm-120.28 168.11c-14.03.02-27.62-4.89-38.39-13.88.49-.26 1.34-.73 1.89-1.07l63.72-36.8c3.26-1.85 5.26-5.32 5.24-9.07v-89.83l26.93 15.55c.29.14.48.42.52.74v74.39c-.04 33.08-26.83 59.9-59.91 59.97zm-128.84-55.03c-7.03-12.14-9.56-26.37-7.15-40.18.47.28 1.3.79 1.89 1.13l63.72 36.8c3.23 1.89 7.23 1.89 10.47 0l77.79-44.92v31.1c.02.32-.13.63-.38.83l-64.41 37.19c-28.69 16.52-65.33 6.7-81.92-21.95zm-16.77-139.09c7-12.16 18.05-21.46 31.21-26.29 0 .55-.03 1.52-.03 2.2v73.61c-.02 3.74 1.98 7.21 5.23 9.06l77.79 44.91-26.93 15.55c-.27.18-.61.21-.91.08l-64.42-37.22c-28.63-16.58-38.45-53.21-21.95-81.89zm221.26 51.49-77.79-44.92 26.93-15.54c.27-.18.61-.21.91-.08l64.42 37.19c28.68 16.57 38.51 53.26 21.94 81.94-7.01 12.14-18.05 21.44-31.2 26.28v-75.81c.03-3.74-1.96-7.2-5.2-9.06zm26.8-40.34c-.47-.29-1.3-.79-1.89-1.13l-63.72-36.8c-3.23-1.89-7.23-1.89-10.47 0l-77.79 44.92v-31.1c-.02-.32.13-.63.38-.83l64.41-37.16c28.69-16.55 65.37-6.7 81.91 22 6.99 12.12 9.52 26.31 7.15 40.1zm-168.51 55.43-26.94-15.55c-.29-.14-.48-.42-.52-.74v-74.39c.02-33.12 26.89-59.96 60.01-59.94 14.01 0 27.57 4.92 38.34 13.88-.49.26-1.33.73-1.89 1.07l-63.72 36.8c-3.26 1.85-5.26 5.31-5.24 9.06l-.04 89.79zm14.63-31.54 34.65-20.01 34.65 20v40.01l-34.65 20-34.65-20z" />
      </svg>
    ),
  },
  {
    name: 'Claude',
    onHome: true,
    description:
      'Claude est un assistant IA développé par Anthropic, conçu pour être utile, honnête et inoffensif dans ses interactions.',
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 520 520"
        height="70"
        width="70"
      >
        <path
          fill="#D77655"
          d="M115.612 0h280.775C459.974 0 512 52.026 512 115.612v278.415c0 63.587-52.026 115.612-115.613 115.612H115.612C52.026 509.639 0 457.614 0 394.027V115.612C0 52.026 52.026 0 115.612 0z"
        />
        <path
          fill="#FCF2EE"
          fill-rule="nonzero"
          d="M142.27 316.619l73.655-41.326 1.238-3.589-1.238-1.996-3.589-.001-12.31-.759-42.084-1.138-36.498-1.516-35.361-1.896-8.897-1.895-8.34-10.995.859-5.484 7.482-5.03 10.717.935 23.683 1.617 35.537 2.452 25.782 1.517 38.193 3.968h6.064l.86-2.451-2.073-1.517-1.618-1.517-36.776-24.922-39.81-26.338-20.852-15.166-11.273-7.683-5.687-7.204-2.451-15.721 10.237-11.273 13.75.935 3.513.936 13.928 10.716 29.749 23.027 38.848 28.612 5.687 4.727 2.275-1.617.278-1.138-2.553-4.271-21.13-38.193-22.546-38.848-10.035-16.101-2.654-9.655c-.935-3.968-1.617-7.304-1.617-11.374l11.652-15.823 6.445-2.073 15.545 2.073 6.547 5.687 9.655 22.092 15.646 34.78 24.265 47.291 7.103 14.028 3.791 12.992 1.416 3.968 2.449-.001v-2.275l1.997-26.641 3.69-32.707 3.589-42.084 1.239-11.854 5.863-14.206 11.652-7.683 9.099 4.348 7.482 10.716-1.036 6.926-4.449 28.915-8.72 45.294-5.687 30.331h3.313l3.792-3.791 15.342-20.372 25.782-32.227 11.374-12.789 13.27-14.129 8.517-6.724 16.1-.001 11.854 17.617-5.307 18.199-16.581 21.029-13.75 17.819-19.716 26.54-12.309 21.231 1.138 1.694 2.932-.278 44.536-9.479 24.062-4.347 28.714-4.928 12.992 6.066 1.416 6.167-5.106 12.613-30.71 7.583-36.018 7.204-53.636 12.689-.657.48.758.935 24.164 2.275 10.337.556h25.301l47.114 3.514 12.309 8.139 7.381 9.959-1.238 7.583-18.957 9.655-25.579-6.066-59.702-14.205-20.474-5.106-2.83-.001v1.694l17.061 16.682 31.266 28.233 39.152 36.397 1.997 8.999-5.03 7.102-5.307-.758-34.401-25.883-13.27-11.651-30.053-25.302-1.996-.001v2.654l6.926 10.136 36.574 54.975 1.895 16.859-2.653 5.485-9.479 3.311-10.414-1.895-21.408-30.054-22.092-33.844-17.819-30.331-2.173 1.238-10.515 113.261-4.929 5.788-11.374 4.348-9.478-7.204-5.03-11.652 5.03-23.027 6.066-30.052 4.928-23.886 4.449-29.674 2.654-9.858-.177-.657-2.173.278-22.37 30.71-34.021 45.977-26.919 28.815-6.445 2.553-11.173-5.789 1.037-10.337 6.243-9.2 37.257-47.392 22.47-29.371 14.508-16.961-.101-2.451h-.859l-98.954 64.251-17.618 2.275-7.583-7.103.936-11.652 3.589-3.791 29.749-20.474-.101.102.024.101z"
        />
      </svg>
    ),
  },
  {
    name: 'Mistral',
    onHome: true,
    description:
      'Mistral est une suite de modèles de langage open source développée par la startup française Mistral AI, axée sur performance et transparence.',
    svg: (
      <svg
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 130"
        height="70"
        width="70"
      >
        <g>
          <rect
            x="18.292"
            y="30"
            width="18.293"
            height="18.123"
            style={{ fill: '#ffd800', fillRule: 'nonzero' }}
          />
          <rect
            x="91.473"
            y="30"
            width="18.293"
            height="18.123"
            style={{ fill: '#ffd800', fillRule: 'nonzero' }}
          />
          <rect
            x="18.292"
            y="48.121"
            width="36.586"
            height="18.123"
            style={{ fill: '#ffaf00', fillRule: 'nonzero' }}
          />
          <rect
            x="73.181"
            y="48.121"
            width="36.586"
            height="18.123"
            style={{ fill: '#ffaf00', fillRule: 'nonzero' }}
          />
          <rect
            x="18.292"
            y="66.243"
            width="91.476"
            height="18.122"
            style={{ fill: '#ff8205', fillRule: 'nonzero' }}
          />
          <rect
            x="18.292"
            y="84.37"
            width="18.293"
            height="18.123"
            style={{ fill: '#fa500f', fillRule: 'nonzero' }}
          />
          <rect
            x="54.883"
            y="84.37"
            width="18.293"
            height="18.123"
            style={{ fill: '#fa500f', fillRule: 'nonzero' }}
          />
          <rect
            x="91.473"
            y="84.37"
            width="18.293"
            height="18.123"
            style={{ fill: '#fa500f', fillRule: 'nonzero' }}
          />
          <rect
            x="0"
            y="102.504"
            width="54.89"
            height="18.123"
            style={{ fill: '#e10500', fillRule: 'nonzero' }}
          />
          <rect
            x="73.181"
            y="102.504"
            width="54.89"
            height="18.123"
            style={{ fill: '#e10500', fillRule: 'nonzero' }}
          />
        </g>
      </svg>
    ),
  },
  {
    name: 'Jest',
    description: 'Framework de test JavaScript puissant et complet.',
    svg: (
      <img src="https://grafikart.fr/uploads/icons/jest.svg" alt="Jest" width="47" height="54" />
    ),
  },
  {
    name: 'RTL',
    description: 'React Testing Library pour tester comme les utilisateurs.',
    svg: (
      <img
        src="https://testing-library.com/img/octopus-64x64.png"
        alt="RTL"
        width="47"
        height="54"
      />
    ),
  },
  {
    name: 'Socket.io',
    description: 'Bibliothèque pour la communication bidirectionnelle en temps réel.',
    svg: (
      <svg width="47" height="54" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <rect fill="#010101" width="47" height="54" rx="2" />
          <circle cx="23.5" cy="27" r="10" fill="none" stroke="#FFF" strokeWidth="2" />
          <path fill="#FFF" d="M23.5 12v30M12 27h23" strokeWidth="1.5" />
        </g>
      </svg>
    ),
  },
  {
    name: 'NestJS',
    description: 'Framework backend progressif pour Node.js.',
    svg: <img src="https://nestjs.com/img/logo-small.svg" alt="NestJS" width="47" height="54" />,
  },
  {
    name: 'Claude',
    description: 'Assistant IA puissant créé par Anthropic pour le raisonnement et le codage.',
    svg: (
      <svg width="47" height="54" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <rect fill="#C15F3C" width="47" height="54" rx="2" />
          <path
            d="m3.127 10.604 3.135-1.76.053-.153-.053-.085H6.11l-.525-.032-1.791-.048-1.554-.065-1.505-.08-.38-.081L0 7.832l.036-.234.32-.214.455.04 1.009.069 1.513.105 1.097.064 1.626.17h.259l.036-.105-.089-.065-.068-.064-1.566-1.062-1.695-1.121-.887-.646-.48-.327-.243-.306-.104-.67.435-.48.585.04.15.04.593.456 1.267.981 1.654 1.218.242.202.097-.068.012-.049-.109-.181-.9-1.626-.96-1.655-.428-.686-.113-.411a2 2 0 0 1-.068-.484l.496-.674L4.446 0l.662.089.279.242.411.94.666 1.48 1.033 2.014.302.597.162.553.06.17h.105v-.097l.085-1.134.157-1.392.154-1.792.052-.504.25-.605.497-.327.387.186.319.456-.045.294-.19 1.23-.37 1.93-.243 1.29h.142l.161-.16.654-.868 1.097-1.372.484-.545.565-.601.363-.287h.686l.505.751-.226.775-.707.895-.585.759-.839 1.13-.524.904.048.072.125-.012 1.897-.403 1.024-.186 1.223-.21.553.258.06.263-.218.536-1.307.323-1.533.307-2.284.54-.028.02.032.04 1.029"
            fill="#FFF"
          />
        </g>
      </svg>
    ),
  },

  {
    name: 'Mistral AI',
    description:
      'Modèle IA performant pour des applications conversationnelles et de raisonnement.',
    svg: (
      <svg
        width="47"
        height="54"
        viewBox="0 0 365 258"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Mistral AI Logo">
          <path d="M104.107 0H52.0525V51.57H104.107V0Z" fill="#FFD800" />
          <path d="M312.351 0H260.296V51.57H312.351V0Z" fill="#FFD800" />
          <path d="M156.161 51.5701H52.0525V103.14H156.161V51.5701Z" fill="#FFAF00" />
          <path d="M312.353 51.5701H208.244V103.14H312.353V51.5701Z" fill="#FFAF00" />
          <path d="M312.356 103.14H52.0525V154.71H312.356V103.14Z" fill="#FF8205" />
          <path d="M104.107 154.71H52.0525V206.28H104.107V154.71Z" fill="#FA500F" />
          <path d="M208.228 154.711H156.174V206.281H208.228V154.711Z" fill="#FA500F" />
          <path d="M312.351 154.711H260.296V206.281H312.351V154.711Z" fill="#FA500F" />
          <path d="M156.195 206.312H0V257.882H156.195V206.312Z" fill="#E10500" />
          <path d="M364.439 206.312H208.244V257.882H364.439V206.312Z" fill="#E10500" />
        </g>
      </svg>
    ),
  },
];

export default SkillsLogos;
